<template>
  <div>
    <Modal v-model="modal" :title="title" @on-visible-change="visible" width="1200" class-name="platform-mapping-modal" :mask-closable="false">
      <Form :model="form" label-position="top" class="platform-mapping-form" :rules="rules"
        :disabled="iptDisabled" ref="formRef" @submit.native.prevent>
        <!--选择平台-->
        <FormItem :label="$t('key1003386')" prop="platformId">
          <Select class="ipt" filterable transfer v-model="form.platformId" @on-change="changePlatform">
            <Option v-for="item in platformList" :value="item.platformId" :key="item.platformId">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <!--选择站点-->
        <FormItem :label="$t('key1003387')" prop="siteId" v-if="!noSitePlatformList.includes(form.platformId)">
          <template #label>
            <span class="red-dot">2. {{ $t('key1003393') }}</span>
          </template>
          <Select v-model="form.siteId" filterable transfer class="ipt" @on-change="siteChange">
            <Option v-for="(item, index) in siteList" :value="item.siteId" :key="index">{{ item.cnName }}</Option>
          </Select>
        </FormItem>
        <!--选择类目-->
        <FormItem v-if="!['shopify'].includes(form.platformId)" popp="ssss">
          <template #label>
          <span class="red-dot"
            v-if="form.platformId &&['walmart', 'alibaba', 'aliexpress'].includes(form.platformId)">2. {{ $t('key1000284') }}</span>
            <span class="red-dot" v-else>3. {{ $t('key1000284') }}</span>
          </template>
          <p>{{ $t('key1001199') }}<span v-if="latelyTree">
            <span
              v-for="item in latelyTree"
              @click="useLatelyTree(item)"
              class="category-tag"
            >{{ recentlyUsedName(item) }}</span
            >
          </span>
          </p>
          <Row :gutter="20">
            <Col :span="6" v-for="(item, index) in list" class="category-box">
              <Card class="box-card" dis-hover>
                <Input
                  v-model.trim="item.search"
                  style="line-height: 36px"
                  clearable
                  @on-change="inputChange($event, index)"
                ></Input>
                <ul
                  class="chose-box"
                  v-if="item.children && item.children.length > 0"
                >
                  <Spin size="large" fix v-if="loading[index]"></Spin>
                  <template v-if="form.platformId === 'walmart'">
                    <li
                      class="chose-category"
                      v-for="(ch, cIndex) in item.children"
                      :class="{
                      'item-active': ch.active,
                      'category-arr': ch.isLeaf === 'N'
                    }"
                      :style="{
                      fontSize: ch.categoryName.length > 32 ? '12px' : '14px'
                    }"
                      :title="ch.categoryName"
                      @click="getCategoryChildren(ch, index + 1, cIndex)"
                    >
                      <span v-if="ch._text" v-html="ch._text"></span>
                      <span v-else>{{ ch.categoryName }}</span>
                    </li>
                  </template>
                  <template v-else>
                    <li
                      class="chose-category"
                      v-for="(ch, cIndex) in item.children"
                      :class="{
                      'item-active': ch.active,
                      'category-arr': ch.isLeaf === 'N'
                    }"
                      :style="{
                      fontSize:
                        (ch.categoryId + '-' + ch.categoryName).length > 32
                          ? '12px'
                          : '14px'
                    }"
                      :title="ch.categoryId + '-' + ch.categoryName"
                      @click="getCategoryChildren(ch, index + 1, cIndex)"
                    >
                      <span v-if="ch._text" v-html="ch._text"></span>
                      <span v-else>{{
                          ch.categoryId + "-" + ch.categoryName
                        }}</span>
                    </li>
                  </template>
                </ul>
              </Card>
            </Col>
          </Row>
          <p class="chose-category-text">
            {{ $t('key1000285') }}<span class="font-weight">{{ activeText.join("->") }}</span>
          </p>
          <p class="redColor" v-if="vaildConfig.category">{{ $t('key1003385') }}</p>
        </FormItem>
        <!--选择Product Type-->
        <FormItem
          :label="$t('key1003388')"
          prop="amazonProductTypeId"
          v-if="
          (!form.platformId || form.platformId === 'amazon') &&
          !['shopify'].includes(form.platformId)
        "
        >
          <Select
            class="ipt"
            filterable
            :placeholder="$t('key1000101')"
            v-model="form.amazonProductTypeId"
            @on-change="changeType"
          >
            <Option
              v-for="item in amazonProductTypeList"
              :value="item.amazonProductTypeId"
            >{{ item.productType }}</Option
            >
          </Select>
          <Select
            class="ml12 ipt"
            v-model="amazonAttributeId"
            v-if="form.platformId === 'amazon' && form.amazonProductTypeId"
            @on-change="getPlatformAttrSetMain"
          >
            <Option
              v-for="{ value, name } in amazonAttributeList"
              :value="value"
            >{{ name }}</Option
            >
          </Select>
        </FormItem>
        <!--选择familyType-->
        <FormItem :label="$t('key1003389')" prop="emagMappedId" v-if="form.platformId === 'emag'">
          <Select class="ipt" filterable :placeholder="$t('key1000101')" v-model="form.emagMappedId" @on-change="getPlatformAttrSetMain">
            <Option v-for="item in emagFamilyTypeList" :value="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <!--商品规格映射-->
        <FormItem :label="$t('key1003390')" v-if="!['shopify'].includes(form.platformId)">
          <template #label>
            <span v-if="form.platformId && ['walmart', 'alibaba', 'aliexpress'].includes(form.platformId)">3. {{ $t('key1003394') }}</span>
            <span v-else-if="!form.platformId || ['amazon'].includes(form.platformId)">5. {{ $t('key1003394') }}</span>
            <span v-else>4. {{ $t('key1003394') }}</span>
          </template>
          <p class="attr-number-box">
            {{ $t('key1003395') }}
            <span class="font-weight-bold">{{ specMatchNumber.allAttr }}</span>
            {{ $t('key1003396') }}<span class="font-weight-bold">{{ specMatchNumber.attr }}</span>
            {{ $t('key1003397') }}<span class="font-weight-bold">{{ specMatchNumber.allAttr - specMatchNumber.attr }}</span>
            {{ $t('key1003398') }}<span class="font-weight-bold">{{ specMatchNumber.allValue }}</span>
            {{ $t('key1003399') }}<span class="font-weight-bold">{{ specMatchNumber.value }}</span>
            {{ $t('key1003400') }}<span class="font-weight-bold">{{ specMatchNumber.allValue - specMatchNumber.value }}</span>
            <Button class="ml10" type="primary" size="small" @click="autoMatch('specMappingData')"
              v-if="(autoMatchConfig.specStatus === 0 || autoMatchConfig.specStatus === 2) && isSave
              && specMappingData && specMappingData.length">{{ $t('key1003401') }}</Button>
            <span class="ml30" v-if="autoMatchConfig.specStatus === 1">
              <Icon type="md-time" class="match-success"/>{{ $t('key1003402') }}</span>
            <span v-if="autoMatchConfig.specStatus === 2" class="ml30">
            <Icon type="ios-checkmark-circle-outline" class="match-success"/>{{ $t('key1003403') }}
              <span class="font-weight-bold">{{ autoMatchConfig.specAttrNumber }}</span>
            {{ $t('key1003404') }}<span class="font-weight-bold">{{ autoMatchConfig.specAttrValueNumber }}</span>
          </span>
          </p>
          <Table height="400" :columns="specMappingColumns" :data="specMappingData">
            <template #ymsAttr="{ index, row }">
              <div v-if="row._attr">
                <Icon :type="!row._switch ? 'md-arrow-dropright' : 'md-arrow-dropdown'"
                  style="cursor: pointer" @click="switchAttrData(row, 'specMappingData')"/>
                {{ row.cnName }}
              </div>
              <div v-else class="flex flex-direction align-items-start">
                <span style="padding-left: 30px">{{ row.cnValue }}</span>
                <span class="themeColor cursor font-size-12 pl30" v-if="
                  row.targetCurrentIndex &&row.endIndex <= row.ymsProductAttributeDictionaryIdList.length"
                  @click="viewMoreOptionalValues(row, 'specMappingData')"
                >{{ $t('key1003405') }}</span>
              </div>
            </template>
            <template #platformAttr="{ index, row }">
              <div class="mapping-platform">
                <div class="mr10" v-for="(item, aIndex) in row.attr" :key="aIndex">
                  <div class="item" v-for="(value, vIndex) in item.valueList" :key="vIndex">
                    <div class="flex align-items-center">
                      <div
                        class="mapping-ipt table-select-null"
                        :class="{
                        'mapping-value-ipt': value.label,
                        'mapping-value-ipt-back': iptDisabled || value.listName
                       }"
                        @mouseenter="value._hasClick = false"
                        v-if="value._hasClick || iptDisabled"
                      >
                        <template v-if="value.label">
                          <template v-if="value.label === 'CUSTOM'">{{
                              $t('key1003378') + handelMappedText(value, true)
                            }}
                          </template>
                          <!--之前是取 value.value，当前先调整为和下拉数据保持一致取value.label (调整的原因是因为当前默认展示的值与下拉框中展示的取值不一致)-->
                          <!--value.label + handelMappedText(value, true)-->
                          <template v-else>{{
                              mappingAttributeValueChange(value, true)
                            }}
                          </template>
                        </template>
                        <template v-else>
                          <template v-if="value.listName && !iptDisabled"
                          >{{ $t('key1000101') }}
                          </template
                          >
                          <template v-else>{{ $t('key1003406') }}</template>
                        </template>
                        <i
                          class="ivu-icon ivu-icon-ios-arrow-down ivu-select-arrow"
                        ></i>
                      </div>
                      <template v-else>
                        <template v-if="value.listName === 'main'">
                          <Select
                            class="mapping-ipt"
                            v-if="specPlatformList"
                            :value="value.value.toUpperCase()"
                            transfer
                            filterable
                            label-in-value
                            @on-change="
                            mappingValueChange(
                              $event,
                              row,
                              aIndex,
                              vIndex,
                              'specMappingData',
                              'main'
                            )
                          "
                          >
                            <Option
                              v-for="(val, idx) in specPlatformList"
                              :key="idx"
                              :value="val.value.toUpperCase()"
                            >{{ val.label + handelMappedText(val) }}</Option
                            >
                          </Select>
                          <div class="mapping-ipt table-select-null" v-else>
                            {{ $t('key1003406') }}<i
                            class="ivu-icon ivu-icon-ios-arrow-down ivu-select-arrow"
                          ></i>
                          </div>
                        </template>
                        <template v-else>
                          <Select
                            class="mapping-ipt"
                            v-if="
                            platformAttributesList[value.listName] &&
                            platformAttributesList[value.listName].length
                          "
                            :value="value.value.toUpperCase()"
                            transfer
                            filterable
                            label-in-value
                            @on-change="
                            mappingValueChange(
                              $event,
                              row,
                              aIndex,
                              vIndex,
                              'specMappingData'
                            )
                          "
                          >
                            <Option
                              v-for="(val, idx) in platformAttributesList[
                              value.listName
                            ]"
                              :key="idx"
                              :value="val.value.toUpperCase()"
                            >{{ val.label + handelMappedText(val) }}</Option
                            >
                          </Select>
                          <div class="mapping-ipt table-select-null" v-else>
                            {{ $t('key1003406') }}<i
                            class="ivu-icon ivu-icon-ios-arrow-down ivu-select-arrow"
                          ></i>
                          </div>
                        </template>
                      </template>
                      <template v-if="row._attr && item.loading">
                      <span class="attr-loading">
                        <Icon type="ios-loading"/>
                      </span>
                      </template>
                      <Icon
                        size="18"
                        type="md-add-circle"
                        v-if="!iptDisabled"
                        @click="addAttr(row, aIndex)"
                      />
                      <Icon
                        size="18"
                        class="ml5"
                        type="md-remove-circle"
                        v-if="
                        ((!row._attr && item.valueList.length > 1) ||
                          (row._attr && row.attr.length > 1)) &&
                        !iptDisabled
                      "
                        @click="removeAttr(row, aIndex, vIndex)"
                      />
                      <span v-else style="width: 23px; height: 1px"></span>
                    </div>
                    <div
                      class="font-size-12 redColor"
                      v-if="
                      value.label &&
                      mappingAttributeValueChange(value, true) === ' '
                    "
                    >
                      {{ $t('key1003392') + value.label }}
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </Table>
        </FormItem>
        <!--商品属性映射-->
        <FormItem :label="$t('key1003391')" v-if="!['shopify'].includes(form.platformId)">
          <template #label>
            <span v-if="form.platformId && ['walmart', 'alibaba', 'aliexpress'].includes(form.platformId)">4. {{ $t('key1003407') }}</span>
            <span v-else-if="!form.platformId || form.platformId === 'amazon'">6. {{ $t('key1003407') }}</span>
            <span v-else>5. {{ $t('key1003407') }}</span>
          </template>
          <p class="attr-number-box">
            {{ $t('key1003395') }}<span class="font-weight-bold">{{ attrMatchNumber.allAttr }}</span>
            {{ $t('key1003396') }}<span class="font-weight-bold">{{ attrMatchNumber.attr }}</span>
            {{ $t('key1003397') }}<span class="font-weight-bold">{{ attrMatchNumber.allAttr - attrMatchNumber.attr }}</span>
            {{ $t('key1003398') }}<span class="font-weight-bold">{{ attrMatchNumber.allValue }}</span>
            {{ $t('key1003399') }}<span class="font-weight-bold">{{ attrMatchNumber.value }}</span>
            {{ $t('key1003400') }}<span class="font-weight-bold">{{ attrMatchNumber.allValue - attrMatchNumber.value }}</span>
            <Button
              class="ml10"
              type="primary"
              size="small"
              @click="autoMatch('attrMappingData')"
              v-if="
              (autoMatchConfig.attrStatus === 0 ||
                autoMatchConfig.attrStatus === 2) &&
              isSave &&
              attrMappingData &&
              attrMappingData.length
            "
            >{{ $t('key1003401') }}</Button
            >
            <span class="ml30" v-if="autoMatchConfig.attrStatus === 1">
              <Icon type="md-time" class="match-success"/>{{ $t('key1003402') }}</span>
            <span v-if="autoMatchConfig.attrStatus === 2" class="ml30">
            <Icon type="ios-checkmark-circle-outline" class="match-success"/>
            {{ $t('key1003403') }}
            <span class="font-weight-bold">{{ autoMatchConfig.attrNumber }}</span>
            {{ $t('key1003404') }}<span class="font-weight-bold">{{ autoMatchConfig.attrValueNumber }}</span>
          </span>
          </p>
          <Table height="400" :columns="attrMappingColumns" :data="attrMappingData">
            <!--YMS属性-->
            <template #ymsAttr="{ index, row }">
              <div v-if="row._attr ">
                <Icon v-if="row.type !==0" :type="!row._switch ? 'md-arrow-dropright' : 'md-arrow-dropdown'"
                  style="cursor: pointer" @click="switchAttrData(row, 'attrMappingData')"/>
                {{ row.cnName }}
              </div>
              <div v-else class="flex flex-direction align-items-start">
                <!-- 关联属性-->
                <div style="padding-left:30px;" class="flex align-items-center"
                  v-if="row.ymsProductAttributeTemplates && row.ymsProductAttributeTemplates.length>0">
                  <Icon :type="!row._associationPropertyShow ? 'md-arrow-dropright' : 'md-arrow-dropdown'"
                    style="cursor: pointer" @click="switchAssociationProperty(row, 'attrMappingData', index)"/>
                  <span>{{ row.cnValue }}</span>
                </div>
                <!-- 关联属性-可选值-->
                <div style="padding-left:70px;" class="flex align-items-center" v-else-if="row.optionalValuesForSubAttributesTalg">
                  <span>{{ $t('key1003408') }}</span>
                  <Icon v-if="row.type !==0" :type="!row._subAssociationPropertyShow ? 'md-arrow-dropright' : 'md-arrow-dropdown'"
                    style="cursor: pointer" @click="switchSubAssociationProperty(row, 'attrMappingData', index)"/>
                  <span>{{ row.cnValue }}</span>
                </div>
                <span v-else :style="row.associationPropertyTalg ? {paddingLeft: '50px'} : row.optionalValuesForSubAttributesTalg ?
                {paddingLeft: '80px'} : row.subAttributeTalg ? {paddingLeft: '150px'} : {paddingLeft: '30px'}">
                  {{ row.cnValue }}
                </span>
                <span
                  class="themeColor cursor font-size-12 pl30"
                  v-if="row.targetCurrentIndex && row.endIndex <= row.ymsProductAttributeDictionaryIdList.length"
                  @click="viewMoreOptionalValues(row, 'attrMappingData')"
                >{{ $t('key1003405') }}</span>
              </div>
            </template>
            <!--平台属性-->
            <template #platformAttr="{ index, row }">
              <div class="mapping-platform">
                <span v-if="row.optionalValuesForSubAttributesTalg">{{ $t('key1003408') }}</span>
                <div class="mr10" v-for="(item, aIndex) in row.attr" :key="aIndex">
                  <div :style="row.subAttributeTalg ? {paddingLeft: '70px'}: ''" class="item" v-for="(value, vIndex) in item.valueList" :key="vIndex">
                    <div class="flex align-items-center">
                      <div class="mapping-ipt table-select-null" :class="{'mapping-value-ipt': value.label,'mapping-value-ipt-back': iptDisabled || value.listName}"
                        @mouseenter="value._hasClick = false" v-if="value._hasClick || iptDisabled">
                        <template v-if="value.label">
                          <template v-if="value.label === 'CUSTOM'">{{
                              $t('key1003378') + handelMappedText(value, true)
                            }}
                          </template>
                          <template v-else>{{ mappingAttributeValueChange(value, true) }}</template>
                        </template>
                        <template v-else>
                          <template v-if="value.listName && !iptDisabled">{{ $t('key1000101') }}</template>
                          <template v-else>{{ $t('key1003406') }}</template>
                        </template>
                        <i class="ivu-icon ivu-icon-ios-arrow-down ivu-select-arrow"></i>
                      </div>
                      <template v-else>
                        <template v-if="value.listName === 'main'">
                          <Select
                            class="mapping-ipt"
                            v-if="attrPlatformList"
                            :value="value.value.toUpperCase()"
                            transfer
                            filterable
                            label-in-value
                            @on-change="mappingValueChange($event,row,aIndex,vIndex,'attrMappingData','main')">
                            <Option
                              v-for="(val, idx) in attrPlatformList"
                              :key="idx"
                              :value="val.value.toUpperCase()">{{ val.label + handelMappedText(val) }}</Option>
                          </Select>
                          <div class="mapping-ipt table-select-null" v-else>
                            {{ $t('key1003406') }}
                            <i class="ivu-icon ivu-icon-ios-arrow-down ivu-select-arrow"></i>
                          </div>
                        </template>
                        <template v-else>
                          <Select
                            class="mapping-ipt"
                            v-if="(platformAttributesList[value.listName] && platformAttributesList[value.listName].length) ||
                            row.optionalValuesForSubAttributesTalg"
                            :value="value.value.toUpperCase()"
                            transfer
                            filterable
                            label-in-value
                            @on-change="mappingValueChange($event,row,aIndex,vIndex,'attrMappingData', null, index)">
                            <Option v-for="(val, idx) in platformAttributesList[value.listName]" :key="idx"
                              :value="val.value.toUpperCase()">{{ val.label + handelMappedText(val) }}</Option>
                          </Select>
                          <div class="mapping-ipt table-select-null" v-else>
                            {{ $t('key1003406') }}
                            <i class="ivu-icon ivu-icon-ios-arrow-down ivu-select-arrow"></i>
                          </div>
                        </template>
                      </template>
                      <template v-if="row._attr && item.loading">
                      <span class="attr-loading">
                        <Icon type="ios-loading"/>
                      </span>
                      </template>
                      <Icon
                        size="18"
                        type="md-add-circle"
                        v-if="!iptDisabled"
                        @click="addAttr(row, aIndex, 'attrMappingData', index)"/>
                      <Icon
                        size="18"
                        class="ml5"
                        type="md-remove-circle"
                        v-if="((!row._attr && item.valueList.length > 1) || (row._attr && row.attr.length > 1)) && !iptDisabled"
                        @click="removeAttr(row, aIndex, vIndex, 'attrMappingData', index)"/>
                      <span v-else style="width: 23px; height: 1px"></span>
                    </div>
                    <div class="font-size-12 redColor" v-if="value.label && mappingAttributeValueChange(value, true) === ' '">
                      {{ $t('key1003392') + value.label }}
                    </div>
                  </div>
                </div>
                <span class="cursor themeColor" v-if="row.unitsTalg && row.attr[0].valueList.some((ele) => ele.value)" @click="unitsBtn(row)">{{ $t('key1003255') }}</span>
              </div>
            </template>
          </Table>
        </FormItem>
      </Form>
      <template #footer>
        <Button @click="modal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="save" v-if="!iptDisabled">{{ $t('key1000111') }}</Button>
      </template>
    </Modal>
    <!--单位换算-->
    <unitsModal ref="units" @updateUnits="updateUnits"></unitsModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';


import api from "@/api/";
import Mixin from "@/components/mixin/common_mixin";
import Vue from "vue";
import unitsModal from "@/views/yms/components/commodityManage/unitsModal.vue";
import {
  mappingLang,
  LISTING_INPUT_TYPE,
  NOSITEPLATFORMLIST
} from "@/utils/enum";
import {getDataSetBatchList, getEnabledPlatforms, getEnumName, handerDataSorting, setConfigCharacters} from "@/utils/common";

const ec = (data, fn) => {
  data.forEach((i) => {
    fn(i);
    if (i.children) {
      ec(i.children, fn);
    }
  });
};
export default {
  mixins: [Mixin],
  props: {
    ymsProductCategoryId: {
      type: String
    }
  },
  data() {
    let v = this;
    return {
      vaildConfig: {
        category: false
      },
      matchText: "",
      attrMatchNumber: {
        allAttr: 0,
        attr: 0,
        allValue: 0,
        value: 0
      },
      specMatchNumber: {
        allAttr: 0,
        attr: 0,
        allValue: 0,
        value: 0
      },
      title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003368'),
      modal: false,
      amazonProductTypeId: "",
      form: {
        amazonCategoryParamBo: null, //amazon平台 拓展字段 ,
        categoryId: "", //分类id ,
        categoryTree: "", //平台分类树 ,
        extendJson: "", // amazon平台 extendJson拓展字段 ,
        platformId: "", // 平台流水号 ,
        productCategoryId: "", //商品分类流水号 ,
        siteId: "", // 站点id ,
        amazonProductTypeId: "",
        emagMappedId: null,
        updateYmsListingCategoryMappingAttributeBos: [], // 平台属性映射信息 ,
        ymsListingCategoryMappingId: null // 刊登类目映射流水号
      },
      isSave: false,
      saveData: {
        cateSeqId: "",
        categoryId: "",
        rootCategoryId: "",
        label: ""
      },
      type: "",
      rules: {
        platformId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003369'), trigger: "change"}
        ],
        siteId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003370'), trigger: "change"}
        ],
        amazonProductTypeId: [
          {
            required: true,
            validator: v.amazonProductTypeValidator,
            trigger: "change"
          }
        ],
        emagMappedId: [
          {
            required: true,
            validator: v.familtTypeValidator,
            trigger: "change"
          }
        ]
      },
      rootCategoryId: "",
      dialogVisible: false,
      list: [
        {
          search: "",
          children: []
        }
      ],
      loading: [false],
      categoryValue: [],
      activeText: [],
      amazonProductTypeList: [],
      amazonAttributeId: "",
      amazonAttributeList: [],
      emagFamilyTypeList: [],
      specMappingColumns: [
        {
          title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000286')}`,
          width: 230,
          tree: true,
          fixed: "left",
          key: "cnName",
          slot: "ymsAttr"
          /*render(h,params) {
            return h('div',[
              h('p',params.row._attr.cnName + ':' + params.row.cnValue)
            ]);
          }*/
        },
        {
          title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000397')}`,
          key: "type",
          fixed: "left",
          minWidth: 150,
          render(h, params) {
            let type = params.row.type;
            let text = getEnumName(v.enumData, 'YmsProductAttributeValueTypeCoreEnum', type);
            return h("span", text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003371'),
          key: "platformAttr",
          minWidth: 1500,
          slot: "platformAttr"
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003372'),
          width: 150,
          key: "platform",
          fixed: "right",
          render(h, params) {
            if (params.row._attr) {
              let _value = [];
              params.row.attr.forEach((i) => {
                i.valueList.forEach((j) => {
                  if (j.value) {
                    let obj = v.platformAttributesList["main"].filter(
                      (k) => k.value.toUpperCase() === j.value.toUpperCase()
                    );
                    if (obj && obj.length) {
                      LISTING_INPUT_TYPE.forEach((i) => {
                        if (i.value === obj[0].inputType) {
                          _value.push(obj[0].attributeText + ":" + i.label);
                        }
                      });
                    }
                  }
                });
              });
              return h(
                "div",
                {
                  style: {
                    lineHeight: "18px"
                  }
                },
                _value.join(",")
              );
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          width: 100,
          fixed: "right",
          key: "operation",
          render(h, params) {
            return (
              v.iptDisabled ||
              h(
                "span",
                {
                  class: "mapping-reset",
                  on: {
                    click() {
                      // 重置属性
                      let id = params.row.id;
                      v.resetTableDate(
                        "specMappingData",
                        params.row._attr,
                        id
                      );
                    }
                  }
                },
                aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000109')
              )
            );
          }
        }
      ],
      attrMappingColumns: [
        {
          title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000286')}`,
          minWidth: 350,
          tree: true,
          fixed: "left",
          slot: "ymsAttr"
        },
        {
          title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000397')}`,
          key: "type",
          fixed: "left",
          minWidth: 150,
          render(h, params) {
            if (!params.row.subAttributeTalg) {
              let type = params.row.type;
              let text = getEnumName(v.enumData, 'YmsProductAttributeValueTypeCoreEnum', type);
              return h("span", text);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003371'),
          key: "platformAttr",
          minWidth: 1500,
          slot: "platformAttr"
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003372'),
          width: 150,
          key: "platform",
          fixed: "right",
          render(h, params) {
            if (params.row._attr) {
              let _value = [];
              params.row.attr.forEach((i) => {
                i.valueList.forEach((j) => {
                  if (j.value) {
                    let obj = v.platformAttributesList["main"].filter(
                      (k) => k.value.toUpperCase() === j.value.toUpperCase()
                    );
                    if (obj && obj.length) {
                      LISTING_INPUT_TYPE.forEach((i) => {
                        if (i.value === obj[0].inputType) {
                          _value.push(obj[0].attributeText + ":" + i.label);
                        }
                      });
                    }
                  }
                });
              });
              return h(
                "div",
                {
                  style: {
                    lineHeight: "18px"
                  }
                },
                _value.join(",")
              );
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          width: 100,
          fixed: "right",
          key: "operation",
          render(h, params) {
            return (
              v.iptDisabled ||
              h(
                "span",
                {
                  class: "mapping-reset",
                  on: {
                    click() {
                      // 重置属性
                      let id = params.row.id;
                      v.resetTableDate(
                        "attrMappingData",
                        params.row._attr,
                        id
                      );
                    }
                  }
                },
                aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000109')
              )
            );
          }
        }
      ],
      specMappingData: [],
      attrMappingData: [],
      _specMappingData: [],
      _attrMappingData: [],
      platformList: [],
      siteList: [],
      latelyTree: [],
      platformAttributesList: {
        main: []
      },
      matchLanguage: null,
      index: 0,
      autoMatchConfig: {
        attrStatus: 0,
        specStatus: 0,
        cacheData: [],
        specAttrNumber: 0,
        specAttrValueNumber: 0,
        attrNumber: 0,
        attrValueNumber: 0
      },
      specValueArray: [],
      attrValueArray: [],
      noSitePlatformList: NOSITEPLATFORMLIST,
      allAttributeValueData: [],
      commonCategoryAttributesData: [],
      enumData: []
    };
  },
  methods: {
    visible(value) {
      let v = this;
      // 入口在 open 方法
      if (!value) {
        v.$nextTick(() => {
          if (v.$refs.formRef && v.$refs.formRef.resetFields) {
            v.$refs.formRef.resetFields();
          }
        });

        for (let key in v.form) {
          v.form[key] = "";
        }
        v.activeText = [];
        v.specMappingData = [];
        v.attrMappingData = [];
        v.autoMatchConfig = {
          attrStatus: 0,
          specStatus: 0,
          cacheData: [],
          specAttrNumber: 0,
          specAttrValueNumber: 0,
          attrNumber: 0,
          attrValueNumber: 0
        };
        v.latelyTree = null;
        v.form.updateYmsListingCategoryMappingAttributeBos = [];
        let dom = document.querySelector(
          ".platform-mapping-modal .ivu-modal-body"
        );
        let dom1 = document.querySelectorAll(
          ".platform-mapping-modal .ivu-table-overflowY"
        );
        if (dom) {
          dom.scrollTop = 0;
        }
        if (dom1 && dom1.length) {
          if (dom1[0]) {
            dom1[0].scrollTop = 0;
          }
          if (dom1[1]) {
            dom1[1].scrollTop = 0;
          }
        }
      }
    },
    async open(type, {specData, attrData, index, row}) {
      let v = this;
      let enumKeyList = ['YmsProductAttributeValueTypeCoreEnum'];
      v.enumData = await getDataSetBatchList(enumKeyList);
      if (type === "add") {
        v.title = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003368');
      } else if (type === "edit") {
        v.title = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003373');
      } else if (type === "look") {
        v.title = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003374');
      }
      v.type = type;
      v.index = index;
      v.platformAttributesList = {
        main: []
      };
      v.modal = true;
      _reset();
      let attrTemplateId = attrData.map((i) => i.ymsProductAttributeTemplateId);
      let specTemplateId = specData.map((i) => i.ymsProductAttributeTemplateId);
      getEnabledPlatforms().then((data) => {
        v.platformList = data;
      }); //获取平台
      if (["edit", "look"].includes(type)) {
        v.form = JSON.parse(JSON.stringify(row));
        // 站点
        if (v.form.platformId !== "walmart") {
          v.getSite(v.form.platformId).then((data) => {
            v.siteList = data;
            v.form.siteId = row.siteId;
            let _obj = v.siteList.filter((i) => i.siteId === v.form.siteId);
            if (_obj && _obj.length) {
              v.matchLanguage = _obj[0].language;
            }
          });
        }

        if (v.form.platformId === "alibaba") {
          v.matchLanguage = "CN";
        }

        // 获取云卖属性
        let productType = null;
        let familyTypeId = null;
        if (v.form.platformId === "amazon") {
          productType = row.amazonCategoryParamBo.productType;
        }

        if (v.form.platformId === "emag") {
          familyTypeId = row.emagId ? Number(row.emagId) : null;
        }
        if (v.form.platformId === "amazon") {
          v.form.amazonProductTypeId = row.amazonCategoryParamBo.productType;
          v.amazonProductTypeList = row.amazonProductTypeList.length > 0 ? JSON.parse(row.amazonProductTypeList) : [];
          v.amazonAttributeId = row.amazonAttributeId || null;
          v.amazonAttributeList = row.amazonAttributeList.length > 0 ? JSON.parse(row.amazonAttributeList) : [];
        }

        v.getPlatformAttr(productType, familyTypeId).then((data) => {
          let _data = data ? data.map((i) => {
            return {
              ...i,
              value: i.attributeValue,
              label: i.attributeValue
            };
          }) : [];
          v.$set(v.platformAttributesList, "main", _data);
          let list = [...attrTemplateId, ...specTemplateId];
          v.getBatchAttrValue(list).then((data) => {
            // 需要过滤掉已经停用的属性值
            let newData = data.map((item) => {
              let productAttributeDictionaryBos = item.productAttributeDictionaryBos || [];
              let sortList = productAttributeDictionaryBos.filter((ele) => ele.status === 1);
              item.productAttributeDictionaryBos = sortList.sort(handerDataSorting("sortNo", "asc"));
              return item;
            });
            v.attrMappingData = JSON.parse(JSON.stringify(_setTableData(attrData, newData)));
            v.specMappingData = JSON.parse(JSON.stringify(_setTableData(specData, newData)));
            v._specMappingData = JSON.parse(JSON.stringify(v.specMappingData));
            v._attrMappingData = JSON.parse(JSON.stringify(v.attrMappingData));
            if (["edit", "look"].includes(type)) {
              let _list = row.updateYmsListingCategoryMappingAttributeBos || [];
              _fixMapingData(_list, "specMappingData");
              _fixMapingData(_list, "attrMappingData");
              _handelTableOpen("specMappingData");
              _handelTableOpen("attrMappingData");
              /*  console.log('=======attrMappingData=======', v.attrMappingData);
                console.log('=======_attrMappingData=======', v._attrMappingData);*/
              v.calcMatchNumber();
            }
          });
        });

        v.categoryTree = v.form.categoryTree;
        v.categoryValue = v.form.categoryTree;

        if (v.categoryTree && v.categoryTree.length) {
          v.rootCategoryId = v.categoryTree[0].categoryId;
        }

        v._categoryData(); // 分类数据处理
        /*if (v.form.platformId === 'amazon') {
          v.amazonProductTypeList = [];
          v.getAmazonType().then(data => {
            v.amazonProductTypeList = data;
          });
        }*/

        if (v.form.platformId === "emag") {
          v.emagFamilyTypeList = [];
          v.getEmagType().then((data) => {
            v.form.emagMappedId = row.emagId ? Number(row.emagId) : null;
            v.emagFamilyTypeList = data;
          });
        }

        v.getYmsListingCategoryMappingGetCategoryTree(); // 获取最近分类
      } else {
        let list = [...attrTemplateId, ...specTemplateId];
        v.getBatchAttrValue(list).then((data) => {
          // 需要过滤掉已经停用的属性值
          let newData = data.map((item) => {
            let productAttributeDictionaryBos = item.productAttributeDictionaryBos || [];
            let sortList = productAttributeDictionaryBos.filter((ele) => ele.status === 1);
            item.productAttributeDictionaryBos = sortList.sort(handerDataSorting("sortNo", "asc"));
            return item;
          });
          v.attrMappingData = JSON.parse(JSON.stringify(_setTableData(attrData, newData))
          );
          v.specMappingData = JSON.parse(JSON.stringify(_setTableData(specData, newData))
          );
          v._specMappingData = JSON.parse(JSON.stringify(v.specMappingData));
          v._attrMappingData = JSON.parse(JSON.stringify(v.attrMappingData));
          _handelTableOpen("specMappingData");
          _handelTableOpen("attrMappingData");
          v.calcMatchNumber();
        });
      }

      /**
       *
       * @param originData 属性数据
       * @param tempData 获取属性值数据
       */
      function _setTableData(originData, tempData) {
        let arr = [];
        originData.forEach((i) => {
          tempData.forEach((j) => {
            if (i.ymsProductAttributeTemplateId === j.ymsProductAttributeTemplateId) {
              let unitsTalg_1 = false;
              let unitsTalg_2 = false;
              // 判断主属性type
              if (i.type === 0) {
                unitsTalg_1 = true;
              }
              // 判断关联属性的type
              if (j.productAttributeDictionaryBos) {
                j.productAttributeDictionaryBos.forEach(k => {
                  if (k.ymsProductAttributeTemplates) {
                    unitsTalg_2 = k.ymsProductAttributeTemplates.some((ele => ele.type === 0));
                  }
                });
              }
              let newProductAttributeDictionaryBos = j.productAttributeDictionaryBos || [];
              i._attr = true; // 属性标记
              i._noValue = !j.productAttributeDictionaryBos || j.productAttributeDictionaryBos.length === 0 ? true : false;
              i.attr = Vue.observable([
                {
                  loading: false,
                  valueList: Vue.observable([
                    {
                      value: "",
                      label: "",
                      listName: "main" // 下拉数据的key => platformAttributesList
                    }
                  ])
                }
              ]);
              i.id = i.ymsProductAttributeTemplateId;
              i.ymsProductAttributeDictionaryIdList = j.productAttributeDictionaryBos.map((item) => {
                return item.ymsProductAttributeDictionaryId;
              });
              i.associationTalg = newProductAttributeDictionaryBos.some((p) => p.ymsProductAttributeTemplates !== null);
              i.endIndex = 50;
              i.unitsTalg = unitsTalg_1 || unitsTalg_2;
              i.platformAttributeValueRate = null;
              i.platformAttributeValueUnit = null;
              arr.push(i);
              // 可选值
              let optionalValues = j.productAttributeDictionaryBos.map((k) => {
                k.attr = Vue.observable([
                  {
                    platformAttr: "",
                    valueList: Vue.observable([
                      {
                        value: "",
                        label: "",
                        pValue: "",
                        pLabel: "",
                        listName: "" // 下拉数据的key => platformAttributesList
                      }
                    ])
                  }
                ]);
                k._show = false;
                k.optionalValuesTalg = true;
                k.cnName = k.cnValue;
                k.pId = i.ymsProductAttributeTemplateId;
                k.ymsCategoryProductAttributeId = i.ymsCategoryProductAttributeId;
                k.id = k.ymsProductAttributeDictionaryId;
                k.endIndex = 50;
                k.ymsProductAttributeDictionaryIdList = j.productAttributeDictionaryBos.map((item) => {
                  return item.ymsProductAttributeDictionaryId;
                });
                k.associationTalg = k.ymsProductAttributeTemplates && k.ymsProductAttributeTemplates.length > 0;
                k.platformAttributeValueRate = null;
                k.platformAttributeValueUnit = null;
                return k;
              });
              let relatedValues = [];
              // 关联属性
              j.productAttributeDictionaryBos.forEach((k) => {
                if (k.ymsProductAttributeTemplates && k.ymsProductAttributeTemplates.length > 0) {
                  k.ymsProductAttributeTemplates.forEach((template) => {
                    let productAttributeDictionaryBos = template.productAttributeDictionaryBos || [];
                    let relatedValue = JSON.parse(JSON.stringify({
                      ...template,
                      attr: Vue.observable([
                        {
                          platformAttr: "",
                          valueList: Vue.observable([
                            {
                              value: "",
                              label: "",
                              pValue: "",
                              pLabel: "",
                              listName: ""
                            }
                          ])
                        }
                      ]),
                      _associationPropertyShow: false,
                      associationPropertyTalg: true,
                      cnName: template.cnName || "",
                      cnValue: template.cnName || "",
                      pId: template.ymsProductAttributeDictionaryId,
                      id: template.ymsProductAttributeDictionaryId,
                      subId: template.ymsProductAttributeTemplateId,
                      endIndex: 50,
                      subYmsCategoryProductAttributeId: i.ymsCategoryProductAttributeId,
                      ymsProductAttributeDictionaryIdList: productAttributeDictionaryBos.map((item) => {
                        return item.ymsProductAttributeDictionaryId;
                      }),
                      platformAttributeValueRate: null,
                      platformAttributeValueUnit: null,
                      optionalValuesForSubAttributesTalg: productAttributeDictionaryBos.every((p) => p.ymsProductAttributeTemplates === null)
                    }));
                    relatedValues.push(relatedValue);
                    // 关联属性可选值
                    productAttributeDictionaryBos.map((g) => {
                      let subRelatedValue = JSON.parse(JSON.stringify({
                        ...g,
                        attr: Vue.observable([
                          {
                            platformAttr: "",
                            valueList: Vue.observable([
                              {
                                value: "",
                                label: "",
                                pValue: "",
                                pLabel: "",
                                listName: ""
                              }
                            ])
                          }
                        ]),
                        _subAssociationPropertyShow: false,
                        subAssociationPropertyTalg: true,
                        subAttributeTalg: true,
                        cnName: g.cnValue || "",
                        cnValue: g.cnValue || "",
                        pId: i.ymsProductAttributeTemplateId,
                        id: g.ymsProductAttributeDictionaryId,
                        subpId: g.ymsProductAttributeTemplateId,
                        subYmsCategoryProductAttributeId: i.ymsCategoryProductAttributeId,
                        endIndex: 50,
                        platformAttributeValueRate: null,
                        platformAttributeValueUnit: null,
                      }));
                      relatedValues.push(subRelatedValue);
                    });
                  });
                }
              });
              arr = arr.concat(optionalValues, relatedValues);
            }
          });
        });
        return arr;
      }

      function _setTableDataT(originData, tempData) {
        let arr = [];
        originData.forEach((i) => {
          tempData.forEach((j) => {
            if (
              i.ymsProductAttributeTemplateId === j.ymsProductAttributeTemplateId) {
              arr.push({
                ...i,
                _attr: true,
                _switch: true,
                platformAttributeId: "",
                platformAttributeName: ""
              });
              arr = arr.concat(
                j.productAttributeDictionaryBos.map((k) => {
                  return {
                    ...k,
                    _show: true,
                    ymsCategoryProductAttributeId: i.ymsCategoryProductAttributeId,
                    platformAttributeId: "",
                    platformAttributeName: "",
                    platformAttributeValue: "",
                    platformAttributeValueId: ""
                  };
                })
              );
            }
          });
        });
        return arr;
      }

      // 整理规格属性数据
      function _fixMapingData(data, dataKey = "specMappingData") {
        let _type = dataKey === "specMappingData" ? 1 : 0;
        let text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003375');
        let typeData = data.filter((i) => i.attributeType === _type);
        let _data = _fixListData(typeData);
        _data = _fixListDataByThree(_data);
        if (_data.length < 1) return;
        let _attrLength = _getLen(_data);
        // 建立select
        v[dataKey].forEach((i) => {
          if (i._attr) {
            if (i.attr.length < _attrLength[i.ymsCategoryProductAttributeId]) {
              let len = _attrLength[i.ymsCategoryProductAttributeId] - i.attr.length;
              for (let k = 0; k < len; k++) {
                v.addAttr({_attr: true, id: i.ymsProductAttributeTemplateId}, null, dataKey);
              }
            }
          }
        });
        _data.forEach((k, kIndex) => {
          // 属性值
          v[dataKey].forEach((i) => {
            if (i._attr) {
              if (i.ymsCategoryProductAttributeId === k.ymsCategoryProductAttributeId) {
                k._fixList.forEach((h, hIndex) => {
                  let _index = i.attr.filter((l) => l.valueList.some((v) => v.value)).length;
                  let _attrObj = h[0];
                  i.attr[_index].valueList[0].value = _attrObj.platformAttributeId;
                  i.attr[_index].valueList[0].label = _attrObj.platformAttributeName;
                  if (!i._noValue) {
                    v[dataKey].forEach((f) => {
                      if (f.pId === i.id) {
                        f.attr[_index].valueList.forEach((p) => {
                          p.listName = _attrObj.platformAttributeId;
                          p.pValue = _attrObj.platformAttributeId;
                          p.pLabel = _attrObj.platformAttributeName;
                          p._hasClick = true;
                        });
                      }
                    });
                    let _obj = v.platformAttributesList.main.filter((i) => i.value.toUpperCase() === _attrObj.platformAttributeId.toUpperCase());
                    if (_obj && _obj.length) {
                      let categoryAttributeId = v.platformAttributesList.main.filter(
                        (i) => i.value.toUpperCase() === _attrObj.platformAttributeId.toUpperCase())[0].categoryAttributeId;
                      v.getPlatformAttrValueToList(categoryAttributeId, _attrObj.platformAttributeId);
                    }
                  }
                });
              }
            }
          });
        });

        _data.forEach((k, kIndex) => {
          k.list.forEach((j, jIndex) => {
            v[dataKey].forEach((i) => {
              if (!i._attr) {
                if (j.ymsProductAttributeDictionaryId === i.ymsProductAttributeDictionaryId && j.platformAttributeValueId) {
                  let _pIndex;
                  i.attr.forEach((a, index) => {
                    a.valueList.forEach((b) => {
                      if (b.pValue === j.platformAttributeId) {
                        _pIndex = index;
                      }
                    });
                  });
                  if (_pIndex !== undefined) {
                    if (i.attr[_pIndex].valueList.every((l) => l.value)) {
                      i.attr[_pIndex].valueList.push({
                        value: "",
                        label: "",
                        mappedText: "",
                        listName: i.attr[_pIndex].valueList[0].listName,
                        _hasClick: true,
                        pValue: k.platformAttributeId,
                        pLabel: k.platformAttributeName
                      });
                    }
                    let _index = i.attr[_pIndex].valueList.length - 1;
                    let platformAttributeValue = "";
                    if (j.platformAttributeValue) {
                      platformAttributeValue = j.platformAttributeValue.indexOf(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003375')) > -1
                        ? j.platformAttributeValue.split("（")[0]
                        : j.platformAttributeValue;
                    }
                    i.attr[_pIndex].valueList[_index].value = j.platformAttributeValueId;
                    i.attr[_pIndex].valueList[_index].label = platformAttributeValue;
                    i.attr[_pIndex].valueList[_index].mappedText = text;
                    i.attr[_pIndex].valueList[_index]._hasClick = true;
                  }
                }
              }
              // 单位值
              if (i.ymsCategoryProductAttributeId === j.ymsCategoryProductAttributeId) {
                if (i.ymsProductAttributeDictionaryId === j.ymsProductAttributeDictionaryId) {
                  i.platformAttributeValueRate = j.platformAttributeValueRate || null;
                  i.platformAttributeValueUnit = j.platformAttributeValueUnit || null;
                }
              }
            });
          });
        });
        v["_" + dataKey] = JSON.parse(JSON.stringify(v[dataKey]));

        function _fixListData(typeData) {
          let obj = {};
          let arr = [];
          typeData.forEach((i) => {
            if (obj[i.ymsCategoryProductAttributeId]) {
              obj[i.ymsCategoryProductAttributeId].list.push(i);
            } else {
              obj[i.ymsCategoryProductAttributeId] = {
                ...i,
                list: [i]
              };
            }
          });
          for (let key in obj) {
            arr.push(obj[key]);
          }
          return arr;
        }

        function _fixListDataByThree(data) {
          data.forEach((i) => {
            let obj = {};
            i.list.forEach((j) => {
              if (obj[j.platformAttributeId]) {
                obj[j.platformAttributeId].push(j);
              } else {
                obj[j.platformAttributeId] = [j];
              }
            });
            i._fixList = [];
            for (let key in obj) {
              i._fixList.push(obj[key]);
            }
          });
          return data;
        }

        function _getLen(data) {
          let obj = {};
          data.forEach((i) => {
            let _obj = {};
            i.list.forEach((j) => {
              if (!_obj[j.platformAttributeId]) {
                _obj[j.platformAttributeId] = true;
                if (!obj[i.ymsCategoryProductAttributeId]) {
                  obj[i.ymsCategoryProductAttributeId] = 1;
                } else {
                  obj[i.ymsCategoryProductAttributeId]++;
                }
              }
            });
          });
          return obj;
        }
      }

      // 清空数据
      function _reset() {
        if (v.$refs.formRef && v.$refs.formRef.resetFields) {
          v.$refs.formRef.resetFields();
        }
        for (let key in v.form) {
          v.form[key] = "";
        }
        v.activeText = [];
        v.list = [];
        v.categoryValue = [];
        v.latelyTree = null;
        v.isSave = true;
        v.form.updateYmsListingCategoryMappingAttributeBos = [];
        v.autoMatchConfig = {
          attrStatus: 0,
          specStatus: 0,
          cacheData: [],
          specAttrNumber: 0,
          specAttrValueNumber: 0,
          attrNumber: 0,
          attrValueNumber: 0
        };
      }

      // 这里处理展开收起
      function _handelTableOpen(dataKey) {
        let _tableOpen = v.$store.state.categoryByTableOpen;
        let list = [];
        if (Object.keys(_tableOpen).length > 0) {
          v["_" + dataKey].forEach((i) => {
            if (i._attr) {
              if (_tableOpen[i.ymsProductAttributeTemplateId]) {
                if (
                  i.ymsProductAttributeTemplateId === _tableOpen[i.ymsProductAttributeTemplateId].ymsProductAttributeTemplateId) {
                  list.push(i);
                  i._switch = true;
                } else {
                  i._switch = false;
                }
              }
            }
          });
          if (list.length > 0) {
            list.forEach((row) => v.switchAttrData(row, dataKey, "show"));
          }
        }
        // 默认收起，只展示属性名数据
        else {
          v["_" + dataKey].forEach((i) => {
            if (i._attr) {
              i._switch = false;
            } else {
              i._show = false;
            }
          });
          v[dataKey] = v["_" + dataKey]
            .filter((i) => {
              if (!i._attr && !i._show) {
                return false;
              } else {
                return true;
              }
            })
            .map((i, index) => {
              i._attrIndex = index;
              return i;
            });
        }
        setTimeout(() => {
          v.handlePlatformPropertiesMapped(
            v.attrMappingData,
            v.specMappingData
          );
          v.handlePlatformPropertiesMapped(
            v._attrMappingData,
            v._specMappingData
          );
        }, 3000);
      }
    },
    // 整理分类数据
    _categoryData() {
      let v = this;
      if (!v.form.categoryTree || v.form.categoryTree.length === 0) {
        v.getCategoryList({
          siteId: v.form.siteId,
          platformId: v.form.platformId,
          parentCategoryId: "",
          level: undefined
        }).then((data) => {
          v.list.push({
            children: data,
            original: JSON.parse(JSON.stringify(data)),
            search: ""
          });
        });
        return;
      }
      let _category = v.form.categoryTree;
      _category.forEach((a, index) => {
        v.$set(v.list, index, {
          children: [],
          original: [],
          search: ""
        });
        v.getCategoryList({
          siteId: v.form.siteId,
          platformId: v.form.platformId,
          parentCategoryId:
            index === 0 ? "" : _category[index - 1].categoryId,
          level: index === 0 ? undefined : index + 1
        }).then((data) => {
          let _cateIndex = null;
          data.forEach((i, cateIndex) => {
            if (i.categoryId === a.categoryId) {
              _cateIndex = cateIndex;
              i.active = true;
            }
          });
          v.$set(v.list[index], "children", data);
          v.$set(v.list[index], "original", JSON.parse(JSON.stringify(data)));
          v.$nextTick(() => {
            if (_cateIndex) {
              _categoryScroll(index, _cateIndex);
            }
          });
        });
      });
      v.isSave = true;
      v.activeText = _category.map((i) => {
        if (v.form.platformId === "walmart") {
          return i.categoryName;
        } else {
          return i.categoryId + "-" + i.categoryName;
        }
      });

      function _categoryScroll(index, cateIndex) {
        if (document.querySelectorAll(".category-box .chose-box")) {
          let dom = document.querySelectorAll(".category-box .chose-box")[
            index
          ];
          if (dom) {
            dom.scrollTop = cateIndex * 40;
          }
        }
      }
    },
    amazonProductTypeValidator(rule, value, callback) {
      if (this.form.platformId === "amazon") {
        if (this.form.amazonProductTypeId) {
          callback();
        } else {
          callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003376')));
        }
      } else {
        callback();
      }
    },
    familtTypeValidator(rule, value, callback) {
      if (this.form.platformId === "emag") {
        if (this.form.emagMappedId) {
          callback();
        } else {
          callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003377')));
        }
      } else {
        callback();
      }
    },
    useLatelyTree(data) {
      if (this.iptDisabled) return;
      let _data = JSON.parse(JSON.stringify(data));
      this.list = [];
      this.categoryValue = _data;
      this.form.categoryTree = _data;
      this.form.categoryId = _data[_data.length - 1].categoryId;
      this.isSave = true;
      this._categoryData(); // 整理分类数据
      this.setAttrListMain(_data[_data.length - 1]);
      this.vaildConfig.category = false;
      this.resetTableDate("specMappingData", true);
      this.resetTableDate("attrMappingData", true);
    },
    // 获取最近使用分类树
    getYmsListingCategoryMappingGetCategoryTree() {
      let v = this;
      /* v.axios.get(api.get_ymsListingCategoryMapping_getCategoryTree + '?platformId=' + v.form.platformId + '&siteId=' + v.form.siteId).then(response => {
        if (response.data.code === 0) {
          v.latelyTree = response.data.datas;
        }
      });*/
      v.latelyTree = null;
      v.latelyTree = v.getLatelyCategory();
    },
    getAttributeMappingList(dataKey) {
      let v = this;
      return new Promise((resolve) => {
        v.axios
          .post(
            api.post_ymsListingCategoryMappingAttribute_getAttributeMappingList,
            {
              attributeTemplateListingMappingBos: _getTempParams(dataKey),
              categoryId: v.form.categoryId,
              platformId: v.form.platformId,
              siteId: v.form.siteId,
              attributeType: dataKey === "specMappingData" ? 1 : 0,
              ymsProductCategoryId: v.ymsProductCategoryId
            }
          )
          .then((response) => {
            if (response.data.code === 0) {
              resolve(response.data.datas);
            }
          });
      });

      function _getTempParams(dataKey) {
        let obj = {};
        let arr = [];
        if (dataKey === "specMappingData") {
          v.specMappingData.forEach((i) => {
            if (i._attr) {
              if (!obj[i.id]) {
                obj[i.id] = [];
              }
            }
            if (!i._attr) {
              if (obj[i.pId]) {
                if (!obj[i.pId].includes(i.id)) {
                  obj[i.pId].push(i.id);
                }
              }
            }
          });
        } else {
          v.attrMappingData.forEach((i) => {
            if (i._attr) {
              if (!obj[i.id]) {
                obj[i.id] = [];
              }
            }
            if (!i._attr) {
              if (obj[i.pId]) {
                if (!obj[i.pId].includes(i.id)) {
                  obj[i.pId].push(i.id);
                }
              }
            }
          });
        }
        for (let key in obj) {
          arr.push({
            ymsProductAttributeTemplateId: key,
            ymsProductAttributeDictionaryId: obj[key]
          });
        }
        return arr;
      }
    },
    // 展开可选值
    switchAttrData(row, dataKey, type) {
      if (row.type !== 0) {
        /*this.$set(row, '_switch', !row._switch);
       this['_' + dataKey].forEach(i => {
         if (!i._attr && i.ymsProductAttributeTemplateId === row.ymsProductAttributeTemplateId) {
           i._show = !i._show;
         }
         if (i._attr && i.ymsProductAttributeTemplateId === row.ymsProductAttributeTemplateId) {
           i._switch = !i._switch;
         }
       });
       this[dataKey] = this['_' + dataKey].filter(i => {
         if (!i._attr && !i._show) {
           return false;
         } else {
           return true;
         }
       });
       let _tableOpen = this.$store.state.categoryByTableOpen;
       _tableOpen[row.ymsProductAttributeTemplateId] = row._switch;
       this.$store.commit('categoryByTableOpen', _tableOpen);*/
        let ymsProductAttributeDictionaryIdList = row.ymsProductAttributeDictionaryIdList || [];
        let list = ymsProductAttributeDictionaryIdList.slice(0, row.endIndex);
        if (!["more", "show"].includes(type)) {
          this.$set(row, "_switch", !row._switch);
        }
        let _switch = row._switch;
        this["_" + dataKey].forEach((i, index) => {
          if (!i._attr && i.ymsProductAttributeTemplateId === row.ymsProductAttributeTemplateId) {
            if (list.includes(i.ymsProductAttributeDictionaryId)) {
              i.targetCurrentIndex = false;
              if (!i._show) {
                i._show = !i._show;
                i.startIndex = row.startIndex;
                i.endIndex = row.endIndex;
                i.targetCurrentIndex = list[list.length - 1] === i.ymsProductAttributeDictionaryId;
              }
            }
            if (!type && !_switch) {
              i._show = false;
            }
          }
          if (!["more", "show"].includes(type)) {
            if (i._attr && i.ymsProductAttributeTemplateId === row.ymsProductAttributeTemplateId) {
              i._switch = !i._switch;
            }
          }
        });
        this["_" + dataKey].map((item) => {
          if (!_switch) {
            if (item.ymsProductAttributeTemplateId === row.ymsProductAttributeTemplateId) {
              item._associationPropertyShow = false;
            }
          }
        });
        this[dataKey] = this["_" + dataKey].filter((i) => {
          if (!i._attr && !i._show) {
            return false;
          } else {
            return true;
          }
        });
        let _tableOpen = this.$store.state.categoryByTableOpen;
        _tableOpen[row.ymsProductAttributeTemplateId] = row;
        this.$store.commit("categoryByTableOpen", _tableOpen);
      }
    },
    // 展开关联属性
    switchAssociationProperty(row, dataKey, curenntIndex) {
      let list = [];
      this[dataKey][curenntIndex]._associationPropertyShow = !row._associationPropertyShow;
      let _associationPropertyShow = this[dataKey][curenntIndex]._associationPropertyShow;
      this["_" + dataKey].forEach((i, index) => {
        if (i.ymsProductAttributeDictionaryId === row.ymsProductAttributeDictionaryId) {
          if (row.ymsProductAttributeDictionaryIdList.includes(row.ymsProductAttributeDictionaryId) && i.associationPropertyTalg) {
            list.push(i);
          }
        }
      });
      if (_associationPropertyShow) {
        this[dataKey].splice(curenntIndex + 1, 0, ...list);
      } else {
        this[dataKey].splice(curenntIndex + 1, list.length);
      }
      this.$forceUpdate();
    },
    switchSubAssociationProperty(row, dataKey, curenntIndex) {
      if (row.type !== 0) {
        let list = [];
        this[dataKey][curenntIndex]._subAssociationPropertyShow = !row._subAssociationPropertyShow;
        let _subAssociationPropertyShow = this[dataKey][curenntIndex]._subAssociationPropertyShow;
        this["_" + dataKey].forEach((i, index) => {
          if (i.ymsProductAttributeTemplateId === row.ymsProductAttributeTemplateId) {
            if (row.ymsProductAttributeDictionaryIdList.includes(i.id) && i.subAssociationPropertyTalg) {
              list.push(i);
            }
          }
        });
        let newList = this.uniqueFunc(list, 'id');
        if (_subAssociationPropertyShow) {
          this[dataKey].splice(curenntIndex + 1, 0, ...newList);
        } else {
          this[dataKey].splice(curenntIndex + 1, newList.length);
        }
        this.$forceUpdate();
      }
    },
    // 查看更多可选值
    viewMoreOptionalValues(row, dataKey) {
      let obj = JSON.parse(JSON.stringify(row));
      let startIndex = obj.endIndex;
      let endIndex = startIndex + 50;
      obj.startIndex = startIndex;
      obj.endIndex = endIndex;
      this.switchAttrData(obj, dataKey, "more");
    },
    save() {
      let v = this;
      v.$refs.formRef.validate((valid) => {
        v.vaildConfig.category = !v.isSave;
        if (valid && (v.isSave || ["shopify"].includes(v.form.platformId))) {
          let params = _fixParams(v.form);
          if (params.categoryTree) {
            v.setLatelyCategory(params.categoryTree);
          }
          v.$emit("success", {
            data: params,
            index: v.index,
            type: v.type
          });
          this.modal = false;
        }
      });

      function _fixParams(data) {
        let _params = JSON.parse(JSON.stringify(data));
        console.log(_params, "_params");
        if (_params.platformId === "amazon") {
          let {productType} = v.amazonProductTypeList.filter((i) => i.amazonProductTypeId === v.form.amazonProductTypeId)[0];
          _params.amazonCategoryParamBo = {
            amazonProductTypeId: v.form.amazonProductTypeId,
            productType: productType,
            rootCategoryId: v.rootCategoryId,
            amazonProductTypeList: v.amazonProductTypeList,
            amazonAttributeList: v.amazonAttributeList,
            amazonAttributeId: v.amazonAttributeId
          };
        } else {
          _params.amazonCategoryParamBo = {
            rootCategoryId: v.rootCategoryId
          };
        }
        _params.extendJson = null;
        _params.updateYmsListingCategoryMappingAttributeBos = _fixAttrData();
        _params.platformName = v.platformList.filter(
          (i) => i.platformId === v.form.platformId
        )[0].name;
        if (!v.noSitePlatformList.includes(v.form.platformId)) {
          _params.siteName = v.siteList.filter(
            (i) => i.siteId === v.form.siteId
          )[0].cnName;
        }
        return _params;
      }

      function _fixAttrData() {
        let arr = [];
        v["_specMappingData"].forEach((i) => {
          if (!i._attr) {
            i.attr.forEach((k) => {
              k.valueList.forEach((j) => {
                if (j.pValue) {
                  let platformAttributeValue = "";
                  if (j.label) {
                    platformAttributeValue =
                      j.label.indexOf(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003375')) > -1
                        ? j.label.split("（")[0]
                        : j.label;
                  }
                  arr.push({
                    attributeType: 1,
                    platformAttributeId: j.pValue,
                    platformAttributeName: j.pLabel,
                    platformAttributeValue: platformAttributeValue,
                    platformAttributeValueId: j.value,
                    ymsCategoryProductAttributeId: i.ymsCategoryProductAttributeId,
                    ymsListingCategoryMappingAttributeId:
                    i.ymsListingCategoryMappingAttributeId, // 待定
                    ymsProductAttributeDictionaryId:
                    i.ymsProductAttributeDictionaryId,
                    ymsProductAttributeTemplateId: i.pId
                  });
                }
              });
            });
          }
          if (i._attr && i._noValue) {
            i.attr.forEach((k) => {
              k.valueList.forEach((j) => {
                arr.push({
                  attributeType: 1,
                  platformAttributeId: j.value,
                  platformAttributeName: j.label,
                  platformAttributeValue: "",
                  platformAttributeValueId: "",
                  ymsCategoryProductAttributeId: i.ymsCategoryProductAttributeId,
                  ymsListingCategoryMappingAttributeId:
                  i.ymsListingCategoryMappingAttributeId, // 待定
                  ymsProductAttributeDictionaryId:
                  i.ymsProductAttributeDictionaryId,
                  ymsProductAttributeTemplateId:
                  i.ymsProductAttributeTemplateId
                });
              });
            });
          }
        });
        v["_attrMappingData"].forEach((i) => {
          if (!i._attr) {
            i.attr.forEach((k) => {
              k.valueList.forEach((j) => {
                if (j.pValue) {
                  let platformAttributeValue = "";
                  if (j.label) {
                    platformAttributeValue = j.label.indexOf(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003375')) > -1 ? j.label.split("（")[0] : j.label;
                  }
                  if (!i.associationPropertyTalg) {
                    arr.push({
                      attributeType: 0,
                      platformAttributeId: j.pValue,
                      platformAttributeName: j.pLabel,
                      platformAttributeValue: platformAttributeValue,
                      platformAttributeValueId: j.value,

                      platformAttributeValueRate: i.platformAttributeValueRate,
                      platformAttributeValueUnit: i.platformAttributeValueUnit,

                      ymsCategoryProductAttributeId: i.ymsCategoryProductAttributeId || i.subYmsCategoryProductAttributeId,
                      ymsListingCategoryMappingAttributeId: i.ymsListingCategoryMappingAttributeId, // 待定
                      ymsProductAttributeDictionaryId: i.ymsProductAttributeDictionaryId,
                      ymsProductAttributeTemplateId: i.associationPropertyTalg ? i.subId : i.subAssociationPropertyTalg ? i.subpId : i.pId
                    });
                  }
                }
              });
            });
          }
          if (i._attr && i._noValue) {
            i.attr.forEach((k) => {
              k.valueList.forEach((j) => {
                if (j.value) {
                  arr.push({
                    attributeType: 0,
                    platformAttributeId: j.value,
                    platformAttributeName: j.label,
                    platformAttributeValue: "",
                    platformAttributeValueId: "",

                    platformAttributeValueRate: i.platformAttributeValueRate,
                    platformAttributeValueUnit: i.platformAttributeValueUnit,

                    ymsCategoryProductAttributeId: i.ymsCategoryProductAttributeId || i.subYmsCategoryProductAttributeId,
                    ymsListingCategoryMappingAttributeId: i.ymsListingCategoryMappingAttributeId, // 待定
                    ymsProductAttributeDictionaryId: i.ymsProductAttributeDictionaryId,
                    ymsProductAttributeTemplateId: i.ymsProductAttributeTemplateId
                  });
                }
              });
            });
          }
        });
        return _setPlatformAttributeValueOptionId(arr);
      }

      function _setPlatformAttributeValueOptionId(arr) {
        arr.forEach((i) => {
          if (v.form.platformId === "amazon") {
            let obj = v.platformAttributesList.main.find(
              (k) => k.attributeValue.toUpperCase() === i.platformAttributeId
            );
            if (obj) {
              i.platformAttributeValueOptionId = obj.attributeId;
              i.parentAttr = obj.parentAttr;
              i.platformAttributeId = obj.attributeValue;
            }
          } else if (
            i.platformAttributeId &&
            i.platformAttributeValueId &&
            v.platformAttributesList[i.platformAttributeId]
          ) {
            let obj = v.platformAttributesList[i.platformAttributeId].filter(
              (j) =>
                j.value.toUpperCase() ===
                i.platformAttributeValueId.toUpperCase()
            );
            if (obj && obj.length) {
              i.platformAttributeValueOptionId = obj[0].attributeVariationId;
            }
          }
        });
        return arr;
      }
    },
    //保存
    setLatelyCategory(data) {
      let v = this;
      let obj = {};
      if (!localStorage.getItem("latelyCategory")) {
        obj[v.form.platformId] = {};
        obj[v.form.platformId][v.form.siteId] = [data];
      } else {
        obj = JSON.parse(localStorage.getItem("latelyCategory"));
        if (!obj[v.form.platformId]) {
          obj[v.form.platformId] = {};
        }
        if (!obj[v.form.platformId][v.form.siteId]) {
          obj[v.form.platformId][v.form.siteId] = [];
        }
        let _has = obj[v.form.platformId][v.form.siteId].some((i) => {
          return i.every(
            (a, aIndex) => a.categoryId === data[aIndex].categoryId
          );
        });
        if (!_has) {
          obj[v.form.platformId][v.form.siteId].unshift(data);
          obj[v.form.platformId][v.form.siteId] = obj[v.form.platformId][
            v.form.siteId
          ].slice(0, 3);
        }
      }
      localStorage.setItem("latelyCategory", JSON.stringify(obj));
    },
    getLatelyCategory() {
      let v = this;
      if (localStorage.getItem("latelyCategory")) {
        let obj = JSON.parse(localStorage.getItem("latelyCategory"));
        let siteId = "";
        if (!v.form.siteId) {
          siteId = "NO_SITEID";
        } else {
          siteId = v.form.siteId;
        }
        if (!obj[v.form.platformId]) {
          return [];
        }
        if (!obj[v.form.platformId][siteId]) {
          return [];
        }
        return obj[v.form.platformId][siteId];
      } else {
        return [];
      }
    },
    getPlatformAttrValueToList(platformAttributeId, value) {
      let v = this;
      return new Promise((resolve) => {
        if (v.platformAttributesList[value]) {
          resolve(v.platformAttributesList[value]);
          return;
        }
        v.getPlatformAttrValue({categoryAttributeId: platformAttributeId}).then((data) => {
          let _data1 = data
            ? data.map((i) => {
              return {
                value: i.attributeValue,
                label: i.attributeText,
                attributeVariationId: i.attributeVariationId || null,
                attributeValueId: i.attributeValueId
              };
            }) : [];
          let _obj = v.platformAttributesList.main.filter((k) => {
            return k.value === value;
          });
          if (_obj && _obj.length) {
            let inputType = _obj[0].inputType;
            if (["1", "3", "5"].includes(inputType)) {
              _data1.push({
                value: "CUSTOM",
                label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003378')
              });
            }
          }
          if (value) {
            v.platformAttributesList[value] = _data1;
            // 将属性设为可枚举
            Object.defineProperties(v.platformAttributesList, {
              [value]: {enumerable: true}
            });
          }
          resolve(_data1);
          // 注释的原因： 是因为当value返回的是中文时，通过$set将value作为key,在for in 中 匹配不到对应的key，导致获取不到value值
          /*setTimeout(() => {
            v.$set(v.platformAttributesList, value, _data1);
          });*/
        });
      });
    },
    // 自动匹配
    async autoMatch(dataKey) {
      let v = this;
      let text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003375');
      v.matchText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003379');
      v[dataKey] = v["_" + dataKey].filter((i) => i);
      v.cacheData = JSON.parse(JSON.stringify(v[dataKey]));
      if (dataKey === "attrMappingData") {
        v.autoMatchConfig.attrStatus = 1;
      } else {
        v.autoMatchConfig.specStatus = 1;
      }
      if (
        !v.platformAttributesList.main ||
        v.platformAttributesList.main.length === 0
      ) {
        v.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000102'));
        return;
      }
      v.$Spin.show({
        render: (h) => {
          return h(
            "div",
            {
              style: {
                zIndex: 9999,
                backgroundColor: "#fff",
                padding: "32px 30px",
                borderRadius: "12px"
              }
            },
            [
              h("Icon", {
                class: "loading_modal_style",
                props: {
                  type: "ios-loading",
                  size: 28
                }
              }),
              h(
                "div",
                {
                  style: {
                    marginTop: "5px",
                    fontSize: "17px"
                  }
                },
                aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003380')
              )
            ]
          );
        }
      });
      let lang = mappingLang[v.matchLanguage] || "usName"; // mappingLang
      let valueLang = "";
      if (lang) {
        valueLang = lang.replace("Name", "Value");
      }
      //if (!v.matchLanguage) return
      let matchData = await v.getAttributeMappingList(dataKey);
      v.matchText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003381');
      if (matchData && matchData.length) {
        let _padding = [];
        matchData.forEach((i, index) => {
          v.matchText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003382');
          v[dataKey].forEach((j, jIndex) => {
            if (
              j._attr &&
              j.ymsProductAttributeTemplateId ===
              i.ymsProductAttributeTemplateId
            ) {
              let _allNull = j.attr.every((a) =>
                a.valueList.every((b) => !b.value)
              ); // 所有为空
              let _allIdentical = j.attr.every((a, aIndex) => {
                if (i.listingPlatformAttributeResultList[aIndex]) {
                  return (
                    a.valueList[0].value.toUpperCase() ===
                    i.listingPlatformAttributeResultList[
                      aIndex
                    ].platformAttributeId.toUpperCase()
                  );
                } else {
                  return false;
                }
              });
              if (_allNull || _allIdentical) {
                i.listingPlatformAttributeResultList.forEach((k, kIndex) => {
                  if (j.attr[kIndex]) {
                    j.attr[kIndex].valueList[0].value = k.platformAttributeId;
                    j.attr[kIndex].valueList[0].label =
                      k.platformAttributeName;
                    j.attr[kIndex].valueList[0].mappedText = text;
                    v[dataKey].forEach((l) => {
                      if (l.pId === i.ymsProductAttributeTemplateId) {
                        l.attr[kIndex].valueList.forEach((y) => {
                          /*y.value = '';
                          y.label = '';*/
                          y.pValue = k.platformAttributeId;
                          y.pLabel = k.platformAttributeName;
                          y.listName = k.platformAttributeId;
                          y._hasClick = true;
                        });
                      }
                    });
                  } else {
                    v[dataKey].forEach((l) => {
                      if (
                        l.id === i.ymsProductAttributeTemplateId ||
                        l.pId === i.ymsProductAttributeTemplateId
                      ) {
                        l.attr.push(
                          Vue.observable({
                            loading: false,
                            valueList: Vue.observable([
                              {
                                value: l._attr ? k.platformAttributeId : "",
                                label: l._attr ? k.platformAttributeName : "",
                                _hasClick: true,
                                pValue: l._attr
                                  ? k.platformAttributeId
                                  : undefined,
                                pLabel: l._attr
                                  ? k.platformAttributeName
                                  : undefined,
                                listName: l._attr
                                  ? "main"
                                  : k.platformAttributeId
                              }
                            ])
                          })
                        );
                      }
                    });
                  }
                  let _obj = v.platformAttributesList.main.filter(
                    (h) => h.value === k.platformAttributeId
                  );
                  if (_obj && _obj.length) {
                    let categoryAttributeId = _obj[0].categoryAttributeId;
                    _padding.push(false);
                    v.getPlatformAttrValueToList(
                      categoryAttributeId,
                      k.platformAttributeId
                    )
                      .then((data) => {
                        // 属性
                        let _v = false;
                        _padding.forEach((pad, padIndex) => {
                          if (!pad && !_v) {
                            _padding[padIndex] = true;
                            _v = true;
                          }
                        });
                        v.matchText =
                          aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003382') +
                          "(" +
                          (
                            _padding.filter((p) => true).length /
                            _padding.length
                          ).toFixed(2) +
                          "%)";
                        k.ymsProductAttributeDictionaryListingMappingResults.forEach(
                          (f) => {
                            v[dataKey].forEach((dd) => {
                              if (
                                !dd._attr &&
                                dd.pId === i.ymsProductAttributeTemplateId &&
                                dd.ymsProductAttributeDictionaryId ===
                                f.ymsProductAttributeDictionaryId
                              ) {
                                if (!dd.attr[kIndex].valueList[0].value) {
                                  let platformAttributeValue = "";
                                  if (f.platformAttributeValue) {
                                    platformAttributeValue =
                                      f.platformAttributeValue.indexOf(
                                        aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003375')
                                      ) > -1
                                        ? f.platformAttributeValue.split(
                                          "（"
                                        )[0]
                                        : f.platformAttributeValue;
                                  }
                                  if (
                                    dd.attr[kIndex].valueList.every(
                                      (val) => val.value
                                    )
                                  ) {
                                    dd.attr[kIndex].valueList.push({
                                      value: f.platformAttributeValueId,
                                      label: platformAttributeValue,
                                      pValue: k.platformAttributeId,
                                      mappedText: text,
                                      _hasClick: true,
                                      pLabel: k.platformAttributeName,
                                      listName: k.platformAttributeId
                                    });
                                  } else {
                                    console.log(f.platformAttributeValueId);
                                    let _index = dd.attr[
                                      kIndex
                                    ].valueList.filter(
                                      (val) => val.value
                                    ).length;
                                    dd.attr[kIndex].valueList[_index].value =
                                      f.platformAttributeValueId;
                                    dd.attr[kIndex].valueList[_index].label =
                                      platformAttributeValue;
                                    dd.attr[kIndex].valueList[
                                      _index
                                    ].mappedText = text;
                                    dd.attr[kIndex].valueList[_index].pValue =
                                      k.platformAttributeId;
                                    dd.attr[kIndex].valueList[_index].pLabel =
                                      k.platformAttributeName;
                                    dd.attr[kIndex].valueList[
                                      _index
                                    ].listName = k.platformAttributeId;
                                    dd.attr[kIndex].valueList[
                                      _index
                                    ]._hasClick = true;
                                  }
                                }
                              }
                            });
                          }
                        );
                        if (_padding.every((pad) => pad)) {
                          // 做名称匹配
                          _nameMatch().then(() => {
                            console.log("end");
                            if (dataKey === "attrMappingData") {
                              v.autoMatchConfig.attrStatus = 2;
                              v.autoMatchConfig.attrNumber = 0;
                              v.autoMatchConfig.attrValueNumber = 0;
                              _getNumber("attrNumber", "attrValueNumber");
                            } else {
                              v.autoMatchConfig.specStatus = 2;
                              v.autoMatchConfig.specAttrNumber = 0;
                              v.autoMatchConfig.specAttrValueNumber = 0;
                              _getNumber(
                                "specAttrNumber",
                                "specAttrValueNumber"
                              );
                            }
                            v.calcMatchNumber();
                            v.$Spin.hide();
                          });
                        }
                      })
                      .catch(() => {
                        let _v = false;
                        _padding.forEach((pad, padIndex) => {
                          if (!pad && !_v) {
                            _padding[padIndex] = true;
                            _v = true;
                          }
                        });
                        v.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003383'));
                      });
                  } else {
                    console.log("匹配错误,和属性不匹配");
                    if (dataKey === "attrMappingData") {
                      v.autoMatchConfig.attrStatus = 2;
                      v.autoMatchConfig.attrNumber = 0;
                      v.autoMatchConfig.attrValueNumber = 0;
                      _getNumber("attrNumber", "attrValueNumber");
                    } else {
                      v.autoMatchConfig.specStatus = 2;
                      v.autoMatchConfig.specAttrNumber = 0;
                      v.autoMatchConfig.specAttrValueNumber = 0;
                      _getNumber("specAttrNumber", "specAttrValueNumber");
                    }
                    v.calcMatchNumber();
                    v.$Spin.hide();
                  }
                });
              }
            }
            if (
              index === matchData.length - 1 &&
              jIndex === v[dataKey].length - 1 &&
              _padding.every((pad) => pad)
            ) {
              // 做名称匹配
              _nameMatch().then(() => {
                console.log("end");
                if (dataKey === "attrMappingData") {
                  v.autoMatchConfig.attrStatus = 2;
                  v.autoMatchConfig.attrNumber = 0;
                  v.autoMatchConfig.attrValueNumber = 0;
                  _getNumber("attrNumber", "attrValueNumber");
                } else {
                  v.autoMatchConfig.specStatus = 2;
                  v.autoMatchConfig.specAttrNumber = 0;
                  v.autoMatchConfig.specAttrValueNumber = 0;
                  _getNumber("specAttrNumber", "specAttrValueNumber");
                }
                v.calcMatchNumber();
                v.$Spin.hide();
              });
            }
          });
        });
        setTimeout(() => {
          v.handlePlatformPropertiesMapped(
            v.attrMappingData,
            v.specMappingData
          );
          v.handlePlatformPropertiesMapped(
            v._attrMappingData,
            v._specMappingData
          );
        }, 3000);
      } else {
        _nameMatch().then(() => {
          if (dataKey === "attrMappingData") {
            v.autoMatchConfig.attrStatus = 2;
            v.autoMatchConfig.attrNumber = 0;
            v.autoMatchConfig.attrValueNumber = 0;
            _getNumber("attrNumber", "attrValueNumber");
          } else {
            v.autoMatchConfig.specStatus = 2;
            v.autoMatchConfig.specAttrNumber = 0;
            v.autoMatchConfig.specAttrValueNumber = 0;
            _getNumber("specAttrNumber", "specAttrValueNumber");
          }
          v.calcMatchNumber();
          v.matchText = "";
          v.$Spin.hide();
          setTimeout(() => {
            v.handlePlatformPropertiesMapped(
              v.attrMappingData,
              v.specMappingData
            );
            v.handlePlatformPropertiesMapped(
              v._attrMappingData,
              v._specMappingData
            );
          }, 3000);
        }); // 做名称匹配
      }

      function _getNumber(key, ValueKey) {
        v[dataKey].forEach((i) => {
          if (i._attr) {
            v.cacheData.forEach((j) => {
              if (i.id === j.id) {
                let _valid = i.attr.every((k, index) => {
                  let d = j.attr[index];
                  if (!d) {
                    return false;
                  } else {
                    if (!k.valueList[0].value && !d.valueList[0].value) {
                      return true;
                    }
                  }

                  return k.valueList[0].value === d.valueList[0].value;
                });
                if (!_valid) {
                  v.autoMatchConfig[key] = v.autoMatchConfig[key] + 1;
                }
              }
            });
          }
        });
        v[dataKey].forEach((i) => {
          if (!i._attr) {
            v.cacheData.forEach((j) => {
              if (i.id === j.id) {
                let _valid = i.attr.every((k, index) => {
                  let d = j.attr[index];
                  if (d) {
                    let _valid = true;
                    k.valueList.forEach((j, jIndex) => {
                      if (j.value !== d.valueList[jIndex].value && j.value) {
                        _valid = false;
                      }
                    });
                    return _valid;
                  } else {
                    if (!j.attr[index] && k.valueList.some((i) => i.value)) {
                      return false;
                    } else {
                      return true;
                    }
                  }
                });
                if (!_valid) {
                  v.autoMatchConfig[ValueKey] =
                    v.autoMatchConfig[ValueKey] + 1;
                }
              }
            });
          }
        });
      }

      // 名称匹配
      function _nameMatch() {
        v.matchText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003384');
        return new Promise((resolve) => {
          let _padding = [];
          v[dataKey].forEach((i, index) => {
            if (i._attr) {
              v.platformAttributesList.main.forEach(async (j, jIndex) => {
                if (
                  i[lang].toLocaleLowerCase() ===
                  j.attributeText.toLocaleLowerCase() &&
                  i._attr
                ) {
                  // 没有值才匹配
                  if (
                    !i.attr[0].valueList[0].value ||
                    i.attr[0].valueList[0].value.toLocaleLowerCase() ===
                    j.value.toLocaleLowerCase()
                  ) {
                    i.attr[0].valueList[0].value = j.value;
                    i.attr[0].valueList[0].label = j.label;
                    let categoryAttributeId =
                      v.platformAttributesList.main.filter(
                        (h) =>
                          h.value.toLocaleLowerCase() ===
                          j.value.toLocaleLowerCase()
                      )[0].categoryAttributeId;
                    _padding.push(false);
                    console.log("start");
                    v.getPlatformAttrValueToList(categoryAttributeId, j.value)
                      .then((_data1) => {
                        let _v = false;
                        _padding.forEach((a, padIndex) => {
                          if (!a && !_v) {
                            _v = true;
                            _padding[padIndex] = true;
                          }
                        });
                        v.matchText =
                          aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003384') +
                          "(" +
                          (
                            _padding.filter((p) => true).length /
                            _padding.length
                          ).toFixed(2) +
                          "%)";
                        v[dataKey].forEach((k) => {
                          if (k.pId === i.id) {
                            _data1.forEach((h) => {
                              if (
                                h.value.toLocaleLowerCase() ===
                                k[valueLang].toLocaleLowerCase()
                              ) {
                                if (!k.attr[0].valueList[0].value) {
                                  k.attr[0].valueList[0].value = h.value;
                                  k.attr[0].valueList[0].label = h.label;
                                  k.attr[0].valueList[0].mappedText = text;
                                  k.attr[0].valueList[0]._hasClick = true;
                                }
                              }
                            });
                          }
                        });
                        v[dataKey].forEach((f) => {
                          if (f.pId === i.id) {
                            f.attr[0].valueList.forEach((p) => {
                              p.listName = j.value;
                              p._hasClick = true;
                              p.pValue = j.value;
                              p.pLabel = j.label;
                            });
                          }
                        });
                        // 匹配完成
                        if (_padding.every((pad) => pad)) {
                          resolve();
                        }
                      })
                      .catch(() => {
                        let _v = false;
                        _padding.forEach((pad, padIndex) => {
                          if (!pad && !_v) {
                            _padding[padIndex] = true;
                            _v = true;
                          }
                        });
                        v.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003383'));
                      });
                  }
                }
                // 匹配完成
                if (
                  index === v[dataKey].length - 1 &&
                  jIndex === v.platformAttributesList.main.length - 1 &&
                  _padding.every((pad) => pad)
                ) {
                  resolve();
                }
              });
            } else {
              // 匹配完成
              console.log(index, v[dataKey].length - 1);
              console.log(_padding);
              if (
                index === v[dataKey].length - 1 &&
                _padding.every((pad) => pad)
              ) {
                resolve();
              }
            }
          });
        });
      }
    },
    calcMatchNumber() {
      let v = this;
      setTimeout(_fn, 100);

      function _fn() {
        v.attrMatchNumber.allAttr = v._attrMappingData.filter(
          (i) => i._attr
        ).length;
        v.attrMatchNumber.attr = v._attrMappingData.reduce((a, b) => {
          if (
            b._attr &&
            b.attr.some((i) => i.valueList.some((j) => j.value))
          ) {
            return ++a;
          } else {
            return a;
          }
        }, 0);
        v.attrMatchNumber.allValue = v._attrMappingData.filter(
          (i) => !i._attr
        ).length;
        v.attrMatchNumber.value = v._attrMappingData
          .filter((i) => !i._attr)
          .reduce((a, b) => {
            if (
              !b._attr &&
              b.attr.some((i) => i.valueList.some((j) => j.value))
            ) {
              return ++a;
            } else {
              return a;
            }
          }, 0);

        v.specMatchNumber.allAttr = v._specMappingData.filter(
          (i) => i._attr
        ).length;
        v.specMatchNumber.attr = v._specMappingData.reduce((a, b) => {
          if (
            b._attr &&
            b.attr.some((i) => i.valueList.some((j) => j.value))
          ) {
            return ++a;
          } else {
            return a;
          }
        }, 0);
        v.specMatchNumber.allValue = v._specMappingData.filter(
          (i) => !i._attr
        ).length;
        v.specMatchNumber.value = v._specMappingData
          .filter((i) => !i._attr)
          .reduce((a, b) => {
            if (
              !b._attr &&
              b.attr.some((i) => i.valueList.some((j) => j.value))
            ) {
              return ++a;
            } else {
              return a;
            }
          }, 0);
        v.$forceUpdate();
      }
    },
    // 批量查询属性值
    async getBatchAttrValue(ymsProductAttributeTemplateIds) {
      let v = this;
      return new Promise((resolve) => {
        v.axios.post(api.post_ymsProductAttributeTemplate_queryByTemplateIds, ymsProductAttributeTemplateIds).then((response) => {
          if (response.data.code === 0) {
            v.allAttributeValueData = response.data.datas || [];
            resolve(response.data.datas);
          }
        });
      });
    },

    categoryValidate(rule, value, callback) {
      if (this.form.categoryId) {
        callback();
      } else {
        callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003385')));
      }
    },
    /*获取亚马逊商品type*/
    getAmazonType() {
      let v = this;
      return new Promise((resolve) => {
        v.axios
          .post(api.post_amazon_getProductType, {
            rootCategoryId: v.rootCategoryId, //一级类目categoryId 或者各分类rootCategoryId （测试数据可能存在rootCategoryId 为空）
            siteId: v.form.siteId
          })
          .then((response) => {
            if (response.data.code === 200) {
              resolve(response.data.datas);
            }
          });
      });
    },
    // 获取emag平台的familyType
    getEmagType() {
      let v = this;
      let query = {
        site: v.form.siteId,
        categoryId: v.form.categoryId
      };
      return new Promise((resolve) => {
        v.axios
          .post(api.post_emag_category_getEmagFamilyTypes, query)
          .then((response) => {
            if (response.data.code === 0) {
              resolve(response.data.datas);
            }
          });
      });
    },
    // 切换平台
    async changePlatform() {
      let v = this;
      this.form.siteId = "";
      this.list = [
        {
          search: "",
          children: []
        }
      ];
      this.platformAttributesList.main = [];
      this.resetTableDate("specMappingData", true);
      this.resetTableDate("attrMappingData", true);
      this.form.amazonProductTypeId = "";
      this.amazonProductTypeList = [];
      this.form.emagMappedId = null;
      this.emagFamilyTypeList = [];

      if (v.form.platformId === "alibaba") {
        v.matchLanguage = "CN";
      }

      if (v.noSitePlatformList.includes(this.form.platformId)) {
        _getCategory();
        return;
      }
      this.siteList = await this.getSite(this.form.platformId);

      function _getCategory() {
        v.getYmsListingCategoryMappingGetCategoryTree(); // 获取最近分类
        v.getCategoryList(
          {
            parentCategoryId: "",
            rootCategoryId: "",
            platformId: v.form.platformId,
            siteId: null
          },
          0
        ).then((data) => {
          v.$set(v.list[0], "children", data);
          v.$set(v.list[0], "original", JSON.parse(JSON.stringify(data)));
        }, 0);
      }
    },
    getSite(platform) {
      let v = this;
      return new Promise((resolve) => {
        v.axios
          .get(api.get_erpCommon_queryAccountSite + `${platform}`)
          .then((response) => {
            if (response.data.code === 0) {
              resolve(response.data.datas);
            }
          });
      });
    },
    siteChange() {
      let v = this;
      v.list = [
        {
          search: "",
          children: []
        }
      ];
      this.platformAttributesList.main = [];
      v.resetTableDate("specMappingData", true);
      v.resetTableDate("attrMappingData", true);
      this.form.amazonProductTypeId = "";
      this.amazonProductTypeList = [];
      this.form.emagMappedId = null;
      this.emagFamilyTypeList = [];
      let _obj = v.siteList.filter((i) => i.siteId === v.form.siteId);
      if (_obj && _obj.length) {
        v.matchLanguage = _obj[0].language;
      }

      v.getYmsListingCategoryMappingGetCategoryTree(); // 获取最近分类
      v.getCategoryList(
        {
          parentCategoryId: "",
          rootCategoryId: "",
          platformId: v.form.platformId,
          siteId: v.form.siteId
        },
        0
      ).then((data) => {
        v.$set(v.list[0], "children", data);
        v.$set(v.list[0], "original", JSON.parse(JSON.stringify(data)));
      }, 0);
    },
    saveHandel() {
      this.$emit(
        "save",
        {
          ...this.saveData,
          type: this.type
        },
        this.currentIndex
      );
      this.dialogVisible = false;
    },
    /**
     * @param index 外层
     * @param cIndex 里层
     * */
    setActive(index, cIndex) {
      this.list[index].children.forEach((i) => (i.active = false));
      let obj = this.list[index].children;
      obj[cIndex].active = true;
      this.$set(this.list[index], "children", obj);
      if (this.form.platformId === "walmart") {
        this.activeText[index] =
          this.list[index].children[cIndex].categoryName;
      } else {
        this.activeText[index] =
          this.list[index].children[cIndex].categoryId +
          "-" +
          this.list[index].children[cIndex].categoryName;
      }
    },
    getCategoryChildren(item, index, cIndex) {
      let v = this;
      let talg = false;
      if (v.activeText.length > 0) {
        talg = item.categoryName === v.activeText[0];
      }
      if (v.iptDisabled || talg) return;
      v.setActive(index - 1, cIndex);
      v.isSave = false;
      v.list.splice(index, v.list.length - index);
      if (index === 1) {
        v.rootCategoryId = item.categoryId;
      }
      this.platformAttributesList.main = [];
      v.resetTableDate("specMappingData", true);
      v.resetTableDate("attrMappingData", true);
      if (item.isLeaf === "Y") {
        v.categoryValue[index - 1] = item;
        v.categoryValue.splice(index);
        if (this.form.platformId === "walmart") {
          v.activeText.splice(
            index - 1,
            v.activeText.length - v.list.length + 1,
            item.categoryName
          );
        } else {
          v.activeText.splice(
            index - 1,
            v.activeText.length - v.list.length + 1,
            item.categoryId + "-" + item.categoryName
          );
        }
        v.saveData = {
          ...item
        };

        v.saveData.categoryId = item.categoryId;
        v.saveData.rootCategoryId = v.rootCategoryId;
        v.saveData.cateSeqId = item.cateSeqId;
        v.saveData.label = v.activeText.join("->");
        v.form.categoryId = item.categoryId;
        v.form.categoryTree = JSON.parse(JSON.stringify(v.categoryValue));
        v.isSave = true;
        v.vaildConfig.category = false;
        v.setAttrListMain(item);
        return;
      }
      this.loading[index] = false;
      this.categoryValue[index - 1] = item;
      v.getCategoryList({
        siteId: v.form.siteId,
        platformId: v.form.platformId,
        parentCategoryId: item.categoryId,
        rootCategoryId: item.rootCategoryId,
        level: index + 1 + ""
      }).then((data) => {
        if (index < v.list.length) {
          v.activeText.splice(index, v.activeText.length - index);
        }
        v.$set(v.list, index, {
          children: [],
          original: [],
          search: ""
        });
        v.$set(v.list[index], "children", data);
        v.$set(v.list[index], "original", JSON.parse(JSON.stringify(data)));
      }, index);
    },
    setAttrListMain(lastData) {
      let v = this;
      if (v.form.platformId === "amazon") {
        v.form.amazonProductTypeId = "";
        if (lastData.productType) {
          let productTypeList = lastData.productType.split(",") || [];
          v.amazonProductTypeList = productTypeList.map((i) => {
            return {
              amazonProductTypeId: i,
              productType: i
            };
          });
        }
        v.getPlatformAttrSetMain();
      } else if (v.form.platformId === "emag") {
        v.form.emagMappedId = null;
        v.emagFamilyTypeList = [];
        v.getEmagType().then((data) => {
          v.emagFamilyTypeList = data;
          v.getPlatformAttrSetMain();
        });
      } else {
        v.getPlatformAttrSetMain();
      }
    },
    openSelect(hasClick, value, ref) {
      hasClick = false;
    },
    changeType() {
      this.amazonAttributeId = "";
      this.getPlatformAttrSetMain("amazon");
    },
    getPlatformAttrSetMain(type) {
      let v = this;
      let productType = null;
      let familyTypeId = null;
      let obj = v.amazonProductTypeList.filter(
        (i) => i.amazonProductTypeId === v.form.amazonProductTypeId
      );
      if (obj && obj.length) {
        if (!v.form.amazonCategoryParamBo) {
          v.form.amazonCategoryParamBo = {
            productType: ""
          };
        }
        v.form.amazonCategoryParamBo.productType = obj[0].productType;
        productType = obj[0].productType;
      }
      let familyTypeObj = v.emagFamilyTypeList.filter((i) => i.id === v.form.emagMappedId);
      familyTypeId = familyTypeObj && familyTypeObj.length > 0 ? familyTypeObj[0].id : null;
      v.getPlatformAttr(productType, familyTypeId).then((data) => {
        if (data.length === 0) {
          if (v.modal) {
            /*v.$Message.info('平台属性数据为空');*/
            console.log("--------平台属性数据为空---------");
          }
        }
        v.platformAttributesList = null;
        v.platformAttributesList = {};
        let _data = data
          ? data.map((i) => {
            return {
              ...i,
              value: i.attributeValue,
              label: i.attributeValue
            };
          })
          : [];
        v.$set(v.platformAttributesList, "main", _data);
        if (type === "amazon") {
          v.amazonAttributeId = "";
          let obj = v.platformAttributesList.main.find(
            (i) => i.attributeId === "name"
          );
          if (obj) {
            v.amazonAttributeList = obj.valueListStr
              ? JSON.parse(obj.valueListStr)
              : [];
          }
        }
        v.calcMatchNumber();
      });
    },
    inputChange(e, index) {
      let v = this;
      let _list = this.list[index].original
        .filter((i) => {
          return (i.categoryId + "-" + i.categoryName).includes(
            e.target.value
          );
        })
        .map((i) => {
          let _text;
          if (v.form.platformId === "walmart") {
            _text = i.categoryName.replace(
              e.target.value,
              '<span class="keywords_highlight">$&</span>'
            );
          } else {
            _text = (i.categoryId + "-" + i.categoryName).replace(
              e.target.value,
              '<span class="keywords_highlight">$&</span>'
            );
          }
          i._text = _text;
          return i;
        });

      this.$set(this.list[index], "children", _list);
    },
    getCategoryList(params, index) {
      let v = this;
      return new Promise((resolve) => {
        v.loading[index] = true;
        v.axios
          .post(api.post_listing_queryCategory, params)
          .then((response) => {
            if (response.data.code === 0) {
              v.loading[index] = false;
              resolve(response.data.datas);
            }
          });
      });
    },
    addAttr(row, aIndex, dataKey = "specMappingData", currentIndex) {
      let v = this;
      let newList = JSON.parse(JSON.stringify(v[dataKey]));
      let _newList = JSON.parse(JSON.stringify(v["_" + dataKey]));
      if (row._attr) {
        newList.forEach((i) => {
          if (i.id === row.id || i.pId === row.id) {
            i.attr.push(
              Vue.observable({
                valueList: Vue.observable([
                  {
                    value: "",
                    label: "",
                    listName: i._attr ? "main" : ""
                  }
                ])
              })
            );
          }
        });
        _newList.forEach((i) => {
          if (i.id === row.id || i.pId === row.id) {
            i.attr.push(
              Vue.observable({
                valueList: Vue.observable([
                  {
                    value: "",
                    label: "",
                    listName: i._attr ? "main" : ""
                  }
                ])
              })
            );
          }
        });
      } else {
        let ymsProductAttributeTemplates = row.ymsProductAttributeTemplates || [];
        let associationPropertyTalg = row.associationPropertyTalg;
        if (ymsProductAttributeTemplates.length > 0) {
          if (newList[currentIndex].ymsProductAttributeTemplateId === row.ymsProductAttributeTemplateId) {
            newList[currentIndex].attr[aIndex].valueList.push({
              value: "",
              label: "",
              listName: newList[currentIndex].attr[aIndex].valueList[0].listName,
              pValue: newList[currentIndex].attr[aIndex].valueList[0].pValue,
              pLabel: newList[currentIndex].attr[aIndex].valueList[0].pLabel
            });
          }
          if (_newList[currentIndex].ymsProductAttributeTemplateId === row.ymsProductAttributeTemplateId) {
            _newList[currentIndex].attr[aIndex].valueList.push({
              value: "",
              label: "",
              listName: _newList[currentIndex].attr[aIndex].valueList[0].listName,
              pValue: _newList[currentIndex].attr[aIndex].valueList[0].pValue,
              pLabel: _newList[currentIndex].attr[aIndex].valueList[0].pLabel
            });
          }
        } else if (associationPropertyTalg) {
          newList.forEach((i) => {
            if (i.ymsProductAttributeDictionaryId === row.ymsProductAttributeDictionaryId) {
              i.attr[aIndex].valueList.push({
                value: "",
                label: "",
                listName: i.attr[aIndex].valueList[0].listName,
                _hasClick: true,
                pValue: i.attr[aIndex].valueList[0].pValue,
                pLabel: i.attr[aIndex].valueList[0].pLabel
              });
            }
          });
          _newList.forEach((i) => {
            if (i.ymsProductAttributeDictionaryId === row.ymsProductAttributeDictionaryId) {
              i.attr[aIndex].valueList.push({
                value: "",
                label: "",
                listName: i.attr[aIndex].valueList[0].listName,
                pValue: i.attr[aIndex].valueList[0].pValue,
                pLabel: i.attr[aIndex].valueList[0].pLabel
              });
            }
          });
        } else {
          newList.forEach((i) => {
            if (i.id === row.id) {
              i.attr[aIndex].valueList.push({
                value: "",
                label: "",
                listName: i.attr[aIndex].valueList[0].listName,
                _hasClick: true,
                pValue: i.attr[aIndex].valueList[0].pValue,
                pLabel: i.attr[aIndex].valueList[0].pLabel
              });
            }
          });
          _newList.forEach((i) => {
            if (i.id === row.id) {
              i.attr[aIndex].valueList.push({
                value: "",
                label: "",
                listName: i.attr[aIndex].valueList[0].listName,
                pValue: i.attr[aIndex].valueList[0].pValue,
                pLabel: i.attr[aIndex].valueList[0].pLabel
              });
            }
          });
        }
      }
      v[dataKey] = JSON.parse(JSON.stringify(newList));
      v["_" + dataKey] = JSON.parse(JSON.stringify(_newList));
      this.$forceUpdate();
    },
    removeAttr(row, aIndex, vIndex, dataKey = "specMappingData", currentIndex) {
      let newList = JSON.parse(JSON.stringify(this[dataKey]));
      let _newList = JSON.parse(JSON.stringify(this["_" + dataKey]));
      if (row._attr) {
        newList.forEach((i) => {
          i.attr.splice(aIndex, 1);
        });
        _newList.forEach((i) => {
          i.attr.splice(aIndex, 1);
        });
      } else {
        let ymsProductAttributeTemplates = row.ymsProductAttributeTemplates || [];
        let associationPropertyTalg = row.associationPropertyTalg;
        if (ymsProductAttributeTemplates.length > 0) {
          if (newList[currentIndex].ymsProductAttributeTemplateId === row.ymsProductAttributeTemplateId) {
            newList[currentIndex].attr[aIndex].valueList.splice(vIndex, 1);
          }
          if (_newList[currentIndex].ymsProductAttributeTemplateId === row.ymsProductAttributeTemplateId) {
            _newList[currentIndex].attr[aIndex].valueList.splice(vIndex, 1);
          }
        } else if (associationPropertyTalg) {
          newList.forEach((i) => {
            if (i.ymsProductAttributeDictionaryId === row.ymsProductAttributeDictionaryId) {
              i.attr[aIndex].valueList.splice(vIndex, 1);
            }
          });
          _newList.forEach((i) => {
            if (i.ymsProductAttributeDictionaryId === row.ymsProductAttributeDictionaryId) {
              i.attr[aIndex].valueList.splice(vIndex, 1);
            }
          });
        } else {
          newList.forEach((i) => {
            if (i.id === row.id) {
              i.attr[aIndex].valueList.splice(vIndex, 1);
            }
          });
          _newList.forEach((i) => {
            if (i.id === row.id) {
              i.attr[aIndex].valueList.splice(vIndex, 1);
            }
          });
        }
      }
      this.calcMatchNumber();
      this[dataKey] = JSON.parse(JSON.stringify(newList));
      this["_" + dataKey] = JSON.parse(JSON.stringify(_newList));
      this.$forceUpdate();
    },
    mappingValueChange(e, row, aIndex, vIndex, dataKey = "specMappingData", main, currentIndex) {
      let v = this;
      if (e) {
        let text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003375');
        if (main === "main") {
          if (dataKey === "specMappingData") {
            let arr = JSON.parse(JSON.stringify(v.specValueArray));
            v.specValueArray = [];
            v.$nextTick(() => {
              arr[row._attrIndex] = e.value;
              v.specValueArray = arr;
            });
          } else if (dataKey === "attrMappingData") {
            let arr = JSON.parse(JSON.stringify(v.attrValueArray));
            v.attrValueArray = [];
            v.$nextTick(() => {
              arr[row._attrIndex] = e.value;
              v.attrValueArray = arr;
            });
          }
        }
        return new Promise((resolve) => {
          if (row._attr) {
            let categoryAttributeId = v.platformAttributesList.main.filter(
              (i) => i.value.toUpperCase() === e.value)[0].categoryAttributeId;
            // 将属性设为可枚举
            /*writable: true/false 属性是否写
               * enumerable：true 属性是可枚举
               * */
            Object.defineProperties(v.platformAttributesList, {
              [e.value]: {enumerable: true, writable: true}
            });
            // 是否已经请求过了
            if (v.platformAttributesList[e.value]) {
              _handel();
              v.calcMatchNumber();
              resolve();
              return;
            }
            v[dataKey].forEach((i) => {
              if (i.id === row.id) {
                i.attr[aIndex]["loading"] = true;
                /*v.$set(i.attr[aIndex], 'loading', true);*/
              }
            });
            v.getPlatformAttrValue({categoryAttributeId: categoryAttributeId}).then((data) => {
              let _data = data ? data.map((i) => {
                return {
                  value: i.attributeValue,
                  label: i.attributeText,
                  attributeVariationId: i.attributeVariationId || null,
                  attributeValueId: i.attributeValueId
                };
              }) : [];
              let inputType = v.platformAttributesList.main.filter((k) => {
                return k.value.toUpperCase() === e.value;
              })[0].inputType;
              if (["1", "3", "5"].includes(inputType)) {
                _data.push({
                  value: "CUSTOM",
                  label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003378')
                });
              }
              v.platformAttributesList[e.value] = _data;
              /* v.$set(v.platformAttributesList, e.value, _data);*/
              v.calcMatchNumber();
              _handel();
              resolve();
            });
          } else {
            v.$nextTick(() => {
              let ymsProductAttributeTemplates = row.ymsProductAttributeTemplates || [];
              let associationPropertyTalg = row.associationPropertyTalg;
              if (ymsProductAttributeTemplates.length > 0) {
                if (v[dataKey][currentIndex].ymsProductAttributeTemplateId === row.ymsProductAttributeTemplateId) {
                  _assignmentFun(v[dataKey][currentIndex], aIndex, vIndex);
                }
                if (v["_" + dataKey][currentIndex].ymsProductAttributeTemplateId === row.ymsProductAttributeTemplateId) {
                  _assignmentFun(v["_" + dataKey][currentIndex], aIndex, vIndex);
                }
              } else if (associationPropertyTalg) {
                if (v[dataKey][currentIndex].ymsProductAttributeDictionaryId === row.ymsProductAttributeDictionaryId) {
                  _assignmentFun(v[dataKey][currentIndex], aIndex, vIndex);
                }
                if (v["_" + dataKey][currentIndex].ymsProductAttributeDictionaryId === row.ymsProductAttributeDictionaryId) {
                  _assignmentFun(v["_" + dataKey][currentIndex], aIndex, vIndex);
                }
              } else {
                v[dataKey].forEach((i) => {
                  if (i.id === row.id) {
                    _assignmentFun(i, aIndex, vIndex);
                  }
                });
                v["_" + dataKey].forEach((i) => {
                  if (i.id === row.id) {
                    _assignmentFun(i, aIndex, vIndex);
                  }
                });
              }

              // 获取关联属性下拉框的基础数据
              if (row.optionalValuesTalg) {
                Object.defineProperties(v.platformAttributesList, {
                  [e.value]: {enumerable: true, writable: true}
                });
                /*if (v.platformAttributesList[e.value]) {
                  _handel();
                  v.calcMatchNumber();
                  resolve();
                  return;
                }*/
                v[dataKey].forEach((i) => {
                  if (i.id === row.id) {
                    i.attr[aIndex]["loading"] = true;
                    let obj = i.attr[aIndex].valueList[vIndex];
                    if (obj && obj.listName) {
                      let attributeValueId = v.platformAttributesList[obj.listName].filter(
                        (k) => k.value.toUpperCase() === e.value)[0].attributeValueId;
                      v.getPlatformAttr(null, null, attributeValueId).then((newData) => {
                        let _data = newData ? newData.map((i) => {
                          return {
                            ...i,
                            value: i.attributeValue,
                            label: i.attributeValue
                          };
                        }) : [];
                        let newList = _data.filter((k) => {
                          return (k.variationType === 0 || (k.variationType === 1 && v.specValueArray.every((p) => p !== k.value)));
                        });
                        v.platformAttributesList[e.value] = newList;
                        v.calcMatchNumber();
                        _handel();
                      });
                    }
                  }
                });
              }
              // 获取关联属性可选值下拉框的基础数据
              if (row.optionalValuesForSubAttributesTalg) {
                let listName;
                v[dataKey].forEach((i) => {
                  if (i.id === row.id) {
                    listName = i.attr[aIndex].valueList[vIndex]["listName"];
                  }
                });
                if (listName) {
                  let categoryAttributeId = v.platformAttributesList[listName].filter(
                    (i) => i.value.toUpperCase() === e.value)[0].categoryAttributeId;
                  v.getPlatformAttrValue({categoryAttributeId: categoryAttributeId}).then((data) => {
                    let _data = data ? data.map((i) => {
                      return {
                        value: i.attributeValue,
                        label: i.attributeText,
                        attributeVariationId: i.attributeVariationId || null,
                        attributeValueId: i.attributeValueId
                      };
                    }) : [];
                    let inputType = v.platformAttributesList[listName].filter((k) => {
                      return k.value.toUpperCase() === e.value;
                    })[0].inputType;
                    if (["1", "3", "5"].includes(inputType)) {
                      _data.push({
                        value: "CUSTOM",
                        label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003378')
                      });
                    }
                    v.platformAttributesList[e.value] = _data;
                    v.calcMatchNumber();
                    _handel();
                    resolve();
                  });
                }
              }
              v.calcMatchNumber();
              resolve();
            });
          }
        });

        // 赋值
        function _assignmentFun(i, aIndex, vIndex) {
          i.attr[aIndex]["loading"] = false;
          i.attr[aIndex].valueList[vIndex]["value"] = e.value;
          i.attr[aIndex].valueList[vIndex]["label"] = e.label;
          i.attr[aIndex].valueList[vIndex]["mappedText"] = text;
        }

        function _handel() {
          v[dataKey].forEach((i) => {
            if (row.optionalValuesForSubAttributesTalg) {
              /*if (i.ymsProductAttributeDictionaryId === row.id) {
                _assignmentFun(i, aIndex, vIndex);
              }*/
              if (i.subpId == row.subId) {
                i.attr[aIndex].valueList.forEach((j) => {
                  j.pValue = e.value;
                  j.listName = e.value;
                  j.value = "";
                  j.label = "";
                  j.mappedText = "";
                  j.pLabel = e.label;
                });
              }
            } else {
              if (i.id === row.id) {
                _assignmentFun(i, aIndex, vIndex);
                /*v.$set(i.attr[aIndex], 'loading', false);
                v.$set(i.attr[aIndex].valueList[vIndex], 'value', e.value);
                v.$set(i.attr[aIndex].valueList[vIndex], 'label', e.label);
                v.$set(i.attr[aIndex].valueList[vIndex], 'mappedText', text);*/
              }
              if (i.pId == row.id) {
                i.attr[aIndex].valueList.forEach((j) => {
                  j.pValue = e.value;
                  j.listName = e.value;
                  j.value = "";
                  j.label = "";
                  j.mappedText = "";
                  j.pLabel = e.label;
                });
              }
            }
          });
          v["_" + dataKey].forEach((i) => {
            if (row.optionalValuesForSubAttributesTalg) {
              /*if (i.ymsProductAttributeDictionaryId === row.id) {
                _assignmentFun(i, aIndex, vIndex);
              }*/
              if (i.subpId == row.subId) {
                i.attr[aIndex].valueList.forEach((j) => {
                  j.pValue = e.value;
                  j.listName = e.value;
                  j.value = "";
                  j.label = "";
                  j.mappedText = "";
                  j.pLabel = e.label;
                });
              }
            } else {
              if (i.id === row.id) {
                _assignmentFun(i, aIndex, vIndex);
                /*v.$set(i.attr[aIndex], 'loading', false);
                v.$set(i.attr[aIndex].valueList[vIndex], 'value', e.value);
                v.$set(i.attr[aIndex].valueList[vIndex], 'label', e.label);
                v.$set(i.attr[aIndex].valueList[vIndex], 'mappedText', text);*/
              }
              if (i.pId == row.id) {
                i.attr[aIndex].valueList.forEach((j) => {
                  j.pValue = e.value;
                  j.listName = e.value;
                  j.value = "";
                  j.label = "";
                  j.mappedText = "";
                  j.pLabel = e.label;
                });
              }
            }
          });
          v.$forceUpdate();
        }
      }
    },
    /**
     * 获取平台属性
     * @date: 2021/9/17 16:58
     * @ param
     */
    async getPlatformAttr(productType = undefined, familyTypeId = undefined, variationId) {
      let v = this;
      return new Promise((resolve) => {
        if (!v.form.categoryId) {
          // 没有分类不加载
          resolve([]);
          return;
        }
        let query = {
          platformId: v.form.platformId,
          siteId: v.form.siteId,
          categoryId: v.form.categoryId,
          productType: productType,
          familyTypeId: familyTypeId,
          variationTheme: v.amazonAttributeId,
          variationEnable: "N",
          inputTypes: v.form.platformId === "amazon" ? undefined : ["1", "2", "3", "4", "5"]
        };
        if (variationId) {
          query.variationId = variationId;
        }
        v.axios.post(api.post_category_attribute_getCommonCategoryAttributes, query).then((response) => {
          if (response.data.code === 200) {
            let list = response.data.datas || [];
            let newList = list.map((i) => {
              if (!i.attributeValue) {
                i.attributeValue = i.attributeText;
              }
              return i;
            });
            if (!variationId) {
              v.commonCategoryAttributesData = newList;
            }
            resolve(newList);
          }
        });
      });
    },
    /**
     * 获取平台属性值
     * @date: 2021/9/17 16:58
     * @ param
     */
    getPlatformAttrValue(params) {
      let v = this;
      let productType;
      if (v.form.platformId === "amazon") {
        productType = v.form.amazonCategoryParamBo.productType;
        let obj = v.platformAttributesList.main.find(
          (i) => i.categoryAttributeId === params.categoryAttributeId
        );
        return Promise.resolve(
          obj.valueListStr
            ? JSON.parse(obj.valueListStr).map(({value, name}) => ({
              attributeText: name,
              attributeValue: name,
              attributeValueId: value
            }))
            : []
        );
      }
      return new Promise((resolve) => {
        let query = {
          categoryAttributeId: params.categoryAttributeId,
          platformId: v.form.platformId,
          siteId: v.form.siteId,
          productType: productType,
          attributeText: params.attributeText
        };
        let categoryId = null;
        if (v.activeText.length > 0) {
          categoryId = v.activeText[0].split('-')[0];
        }
        if (v.form.platformId === 'aliexpress' && categoryId === '200000345') {
          query.isSizeModel = 'true';
        }
        v.axios.post(api.post_category_attribute_variation_getAttributeValueByAttributeIdAndAttributeText, query).then((response) => {
          if (response.data.code === 200) {
            let data = response.data.datas || [];
            resolve(data);
          }
        });
      });
    },
    resetTableDate(dataKey = "specMappingData", isAttr, id) {
      let v = this;
      if (isAttr) {
        if (id) {
          // 重置单个 id => index
          v[dataKey].forEach((i) => {
            if (i.id === id) {
              i.attr.forEach((j) => {
                j.valueList.forEach((val) => {
                  val.label = "";
                  val.value = "";
                });
              });
            }
          });
          v[dataKey].forEach((c) => {
            if (c.pId === id) {
              c.attr.forEach((cj) => {
                cj.valueList.splice(1, cj.valueList.length);
                cj.valueList.forEach((val) => {
                  val.label = "";
                  val.pValue = "";
                  val.pLabel = "";
                  val.value = "";
                  val.listName = "";
                });
              });
            }
          });
          v["_" + dataKey].forEach((i) => {
            if (i.id === id) {
              i.attr.forEach((j) => {
                j.valueList.forEach((val) => {
                  val.label = "";
                  val.value = "";
                });
              });
            }
          });
          v["_" + dataKey].forEach((c) => {
            if (c.pId === id) {
              c.attr.forEach((cj) => {
                cj.valueList.splice(1, cj.valueList.length);
                cj.valueList.forEach((val) => {
                  val.label = "";
                  val.pValue = "";
                  val.pLabel = "";
                  val.value = "";
                  val.listName = "";
                });
              });
            }
          });
        } else {
          v[dataKey].forEach((i) => {
            i.attr.forEach((j) => {
              j.valueList.splice(1, j.valueList.length);
              j.valueList.forEach((val) => {
                val.label = "";
                val.value = "";
                val.listName = i._attr ? "main" : "";
                if (!i._attr) {
                  i.pValue = "";
                  i.pLabel = "";
                }
              });
            });
          });
          v["_" + dataKey].forEach((i) => {
            i.attr.forEach((j) => {
              j.valueList.splice(1, j.valueList.length);
              j.valueList.forEach((val) => {
                val.label = "";
                val.value = "";
                val.listName = i._attr ? "main" : "";
                if (!i._attr) {
                  i.pValue = "";
                  i.pLabel = "";
                }
              });
            });
          });
        }
      } else {
        v[dataKey].forEach((j) => {
          if (j.id === id) {
            j.attr.forEach((k) => {
              k.valueList.splice(1, k.valueList.length);
              k.valueList.forEach((val) => {
                val.label = "";
                val.value = "";
              });
            });
          }
        });
        v["_" + dataKey].forEach((j) => {
          if (j.id === id) {
            j.attr.forEach((k) => {
              k.valueList.splice(1, k.valueList.length);
              k.valueList.forEach((val) => {
                val.label = "";
                val.value = "";
              });
            });
          }
        });
      }
      v.calcMatchNumber();
    },
    // 处理对已经选中过的平台属性标记为已映射标识
    handlePlatformPropertiesMapped(attrMappingData, specMappingData) {
      let v = this;
      let data = [...attrMappingData, ...specMappingData] || [];
      if (data.length > 0) {
        let selectValueList = [];

        function attrToList(list, result = []) {
          list.map((item) => {
            item.attr.map((ele) => {
              ele.valueList.map((node) => {
                if (node.label && node.value) {
                  result.push(node.value.toUpperCase());
                }
              });
            });
          });
          return result;
        }

        let newData = data.filter((item) => {
          return item.attr && item.attr.length > 0;
        });
        selectValueList = attrToList(newData);
        if (selectValueList.length > 0) {
          let newList = v.uniqueFunc(selectValueList);
          let text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003375');
          // 检查可枚举属性
          /*console.log('====可枚举属性值=======', Object.keys(v.platformAttributesList));*/
          // 属性值的平台属性标记映射
          if (v.platformAttributesList) {
            for (let key in v.platformAttributesList) {
              let attributesList = [];
              if (key !== "main") {
                let list = v.platformAttributesList[key] || [];
                list.map((ele) => {
                  ele.mappedText = "";
                  if (newList.includes(ele.value.toUpperCase())) {
                    ele.mappedText = text;
                    /* v.$set(v.platformAttributesList[key][idx], 'mappedText', text);
                     v.$forceUpdate();*/
                  }
                });
                // 已经映射的排序到最后
                let mappedList = list.filter((talg) => {
                  return talg.mappedText;
                });
                let noMappedList = list.filter((talg) => {
                  return !talg.mappedText;
                });
                attributesList = v.uniqueFunc(
                  [...noMappedList, ...mappedList],
                  "value"
                );
                v.platformAttributesList[key] = attributesList;
                v.$forceUpdate();
              }
            }
          }

          //属性名的平台属性标记已映射
          let platformAttributesList = v.platformAttributesList["main"];
          if (newList.length > 0) {
            if (platformAttributesList.length > 0) {
              platformAttributesList.map((item, index) => {
                item.mappedText = "";
                if (newList.includes(item.value.toUpperCase())) {
                  v.$set(platformAttributesList[index], "mappedText", text);
                }
              });
              // 已经映射的排序到最后
              let mappedList = platformAttributesList.filter((item) => {
                return item.mappedText;
              });
              let noMappedList = platformAttributesList.filter((item) => {
                return !item.mappedText;
              });
              v.platformAttributesList["main"] = v.uniqueFunc(
                [...noMappedList, ...mappedList],
                "value"
              );
              setTimeout(() => {
                v.$set(
                  v.platformAttributesList["main"][0],
                  "indexs",
                  Math.floor(Math.random() * 1000)
                );
                /* console.log('_________specMappingData_____-', v.specMappingData)
                console.log('_________attrMappingData_____-', v.attrMappingData)
                 console.log('_____当前已经选中的属性名称平台属性___________', newList);
                 console.log('=====platformAttributesList=============', v.platformAttributesList)*/
              }, 2000);
              v.$forceUpdate();
            }
          }
        }
      }
    },
    // 处理展示已映射的文本
    handelMappedText(obj, value) {
      let label = obj.label;
      let text = "";
      if (label.includes(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003375'))) {
        text = "";
      } else {
        if (value) {
          text = obj.mappedText || aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003375');
        } else {
          text = obj.mappedText || "";
        }
      }
      return text;
    },
    // 校验映射过的属性值是否有变更
    mappingAttributeValueChange(obj, value) {
      let talg = true;
      let text = "";
      let newList = this.platformAttributesList[obj.listName] || [];
      if (newList.length > 0) {
        talg = newList.some((item) => {
          return item.value.toUpperCase() === obj.value.toUpperCase();
        });
      }
      if (talg) {
        text = obj.label + this.handelMappedText(obj, value);
      } else {
        text = " ";
      }
      return text;
    },
    // 最近使用
    recentlyUsedName(obj) {
      return obj
        .map((i) => {
          return i.categoryId + "-" + i.categoryName;
        })
        .join(">");
    },
    // 单位换算
    unitsBtn(row) {
      let newList = [];
      if (this.allAttributeValueData.length > 0) {
        let list = this.allAttributeValueData.filter((item) => item.ymsProductAttributeTemplateId === row.id);
        if (list.length > 0) {
          let productAttributeDictionaryBos = list[0].productAttributeDictionaryBos || [];
          let type = list[0].type;
          productAttributeDictionaryBos.map((item) => {
            let ymsProductAttributeTemplates = item.ymsProductAttributeTemplates || [];
            ymsProductAttributeTemplates.map((ele) => {
              if (ele.type === 0) {
                newList.push(...ele.productAttributeDictionaryBos);
              }
            });
          });
          if (type === 0) {
            newList.push(...productAttributeDictionaryBos);
          }
        }
      }
      newList.map((item) => {
        this._attrMappingData.map((ele) => {
          if (item.ymsProductAttributeTemplateId === ele.ymsProductAttributeTemplateId &&
            item.ymsProductAttributeDictionaryId === ele.ymsProductAttributeDictionaryId) {
            item.platformAttributeValueRate = ele.platformAttributeValueRate || null;
            item.platformAttributeValueUnit = ele.platformAttributeValueUnit || null;
          }
        });
      });
      this.$refs['units'].initUnitsData(row, newList, this.commonCategoryAttributesData);
    },
    // 更新换算单位数据
    updateUnits(obj) {
      let platformAttributeUnitList = obj.platformAttributeUnitList || [];
      this.attrMappingData.map((item, index) => {
        platformAttributeUnitList.map((ele) => {
          if (item.ymsProductAttributeTemplateId === ele.ymsProductAttributeTemplateId &&
            item.ymsProductAttributeDictionaryId === ele.ymsProductAttributeDictionaryId) {
            item.platformAttributeValueRate = ele.platformAttributeValueRate;
            item.platformAttributeValueUnit = ele.platformAttributeValueUnit;
          }
        });
      });
      this._attrMappingData.map((item, index) => {
        platformAttributeUnitList.map((ele) => {
          if (item.ymsProductAttributeTemplateId === ele.ymsProductAttributeTemplateId &&
            item.ymsProductAttributeDictionaryId === ele.ymsProductAttributeDictionaryId) {
            item.platformAttributeValueRate = ele.platformAttributeValueRate;
            item.platformAttributeValueUnit = ele.platformAttributeValueUnit;
          }
        });
      });
    }
  },
  computed: {
    iptDisabled() {
      return this.type === "look";
    },
    specPlatformList() {
      const _type = "main";
      if (this.platformAttributesList[_type] && this.platformAttributesList[_type].length) {
        let list = this.platformAttributesList[_type].filter((i) => {
          return (i.variationType === 2 || (i.variationType === 1 && this.attrValueArray.every((j) => j !== i.value)));
        });
        return list;
      } else {
        return [];
      }
    },
    attrPlatformList() {
      const _type = "main";
      if (this.platformAttributesList[_type] && this.platformAttributesList[_type].length) {
        return this.platformAttributesList[_type].filter((i) => {
          return (i.variationType === 0 || (i.variationType === 1 && this.specValueArray.every((j) => j !== i.value)));
        });
      } else {
        return [];
      }
    }
  },
  watch: {
    attrMappingData: {
      handler(data) {
        this.handlePlatformPropertiesMapped(data, this.specMappingData);
      },
      deep: true
    },
    specMappingData: {
      handler(data) {
        this.handlePlatformPropertiesMapped(this.attrMappingData, data);
      },
      deep: true
    },
    _attrMappingData: {
      handler(data) {
        this.handlePlatformPropertiesMapped(data, this._specMappingData);
      },
      deep: true
    },
    _specMappingData: {
      handler(data) {
        this.handlePlatformPropertiesMapped(this._attrMappingData, data);
      },
      deep: true
    }
  },
  components: {
    unitsModal
  }
};
</script>

<style>
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}

.mapping-platform {
  display: flex;
  margin-top: 10px;
}

.mapping-platform .item {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}

.mapping-platform .item .mapping-ipt {
  width: 200px;
  margin-right: 5px;
  min-height: 32px;
}

.platform-mapping-modal .ivu-modal-body {
  height: 600px;
  overflow-y: auto;
}

.platform-mapping-form.ivu-form-label-top .ivu-form-item-label {
  font-weight: bold;
  font-size: 14px;
}

.chose-category-box .el-dialog__body {
  padding-top: 10px;
}

.mapping-reset {
  cursor: pointer;
  color: red;
}

.mapping-reset:hover {
  opacity: 0.9;
}

.table-select-null {
  box-sizing: border-box;
  vertical-align: middle;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
  position: relative;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #dcdee2;
  transition: all 0.2s ease-in-out;
  line-height: 30px;
  padding-left: 8px;
  color: #c5c8ce;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
  "Microsoft YaHei", 微软雅黑, Arial, sans-serif;
  background-color: #f5f5f5;
}

.table-select-null:hover {
  border-color: #57a3f3;
}

.attr-loading {
  width: 18px;
  height: 18px;
  animation: myfirst 3s linear infinite;
  display: flex;
  align-items: center;
  justify-content: center;
}

@keyframes myfirst {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.ivu-form-item-required .red-dot:before {
  content: "" !important;
}

.mapping-value-ipt {
  background-color: #ffffff;
  color: #666;
}

.mapping-value-ipt-back {
  background-color: #ffffff;
}
</style>
<style scoped>
.attr-number-box span {
  padding-right: 6px;
}

.category-tag {
  display: inline-block;
  border: 1px solid #d9d9d9;
  padding: 0px 8px;
  margin-right: 20px;
  font-size: 12px;
  height: 24px;
  line-height: 24px;
  cursor: pointer;
}

.category-tag:hover {
  border: 1px solid #00a0e9;
}

.platform-mapping-form .ipt {
  width: 300px;
}

ul {
  margin: 0;
  padding: 0;
}

.box-card {
  height: 360px;
  margin-bottom: 20px;
}

.item-active {
  background-color: #d8ebf5 !important;
}

.chose-box {
  max-height: 270px;
  width: 100%;
  margin-top: 10px;
  border-radius: 2px;
  overflow: hidden;
  border: 1px solid #cccccc;
  overflow-y: auto;
}

.category-arr:after {
  content: ">";
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  font-family: cursive;
}

.chose-category {
  color: #333;
  line-height: 30px;
  list-style: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /*border-bottom: 1px solid #9e9e9e;*/
  padding: 5px 15px 5px 5px;
  /*background-color: #f4f4f5;*/
  position: relative;
  cursor: pointer;
}

.chose-category:last-child {
  border-bottom: none;
}

.chose-category:hover {
  background-color: #e3e3ea;
}

.chose-category-text {
  font-size: 12px;
  padding: 6px 0;
}

.category-search-ipt {
  margin-bottom: 10px;
}

.keywords_highlight {
  display: inline-block;
  color: #1890ff;
  background-color: transparent !important;
}

.match-success {
  color: #69b6fe;
  margin-right: 5px;
  font-size: 18px;
}
</style>
